<template lang="pug">
  div.container
    el-form(:model="model" label-position="top" label-width="12em")
      vue-form-generator(
        :schema="schema",
        :model="model",
        :options="formOptions"
        ref="form",
        @model-updated="onModelUpdated"
      )
</template>
<script>

import { component as VueFormGenerator } from 'vue-form-generator'
import { schemas, validaCpfCnpj, orgaosExpedidores, siglasEstados } from './schemas'
import utils from '@/utils/utils'
import gentilicos from '@/constants/gentilico-titulo'
import { estadoCivil, finalidade } from '@/utils/select-objects'
import { mapActions } from 'vuex'
import moment from 'moment'
const { tiposProcessoFisico } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default

export default {
  components: {
    VueFormGenerator
  },

  props: {
    despacho: {
      type: Object,
      required: true
    },
    tipo: {
      type: String,
      default: 'NAO_ONEROSO'
    }
  },

  data () {
    return {
      model: {},
      schema: {},
      nomeSchema: '',
      isOutorgadoPessoaFisica: null,
      municipiosListOutorgado: [],
      formOptions: {
        validateAfterLoad: false,
        validateAfterChanged: true,
        validateBeforeSave: true,
        despacho: null,
        //  tipoModelo 5 corresponde à modelos de registro de imovel
        tipoModelo: 5
      },
      isRepresentantesLegais: false,
      camposVtnParcela: ['valorEntradaVtn', 'porcentagemEntradaVtn', 'quantidadeDeParcelas', 'valorParcelasRestantes', 'vencimentoProximaParcela'],
      isMa: process.env.ESTADO === 'ma',
      isAp: process.env.ESTADO === 'ap',
      tiposProcessoFisico,
      isRetificacaoTitulo: this.despacho?.isRetificacaoTitulo || false,
      optionFormat: { prefix: 'R$ ', suffix: '', thousands: '.', decimal: ',', precision: 2 }
    }
  },

  async created () {
    if (this.isMa && (this.isOnerosoNaoOneroso() || this.isReurbIndividual())) {
      if (this.despacho.processo.id) {
        const dadosImovel = await this.getDespachoDadosImovel({ idProcesso: this.despacho.processo.id })
        this.setDadosImovel(dadosImovel)
      }
    }
  },

  beforeDestroy () {
    const groupConjuge = schemas.emissao_titulo[this.nomeSchema].groups.find(group => group.codigo === 'CONJUGE')
    if (groupConjuge) {
      groupConjuge.fields.forEach((field) => {
        field.required = true
        field.visible = true
      })
    }
    if (this.isRepresentantesLegais) {
      const groupRepresentante = schemas.emissao_titulo[this.nomeSchema].groups.find(group => group.codigo === 'OUTORGADO')
      if (groupRepresentante) {
        groupRepresentante.fields = groupRepresentante.fields.filter(field => !field.inputName.includes('representanteLegais'))
      }
    }
    if (this.isEstadMA) {
      const fieldDescricao = this.getField('descricao', 'caracteristica_model')
      fieldDescricao.visible = false
      fieldDescricao.required = false
    }
  },

  async mounted () {
    this.nomeSchema = this.despacho?.tituloDespacho?.tituloProcessoDTO?.novaPortaria ? `${this.tipo}_NOVA_PORTARIA` : this.tipo
    this.schema = schemas.emissao_titulo[this.nomeSchema]
    this.isOutorgadoPessoaFisica = !!this.despacho?.tituloDespacho?.tituloProcessoDTO?.outorgado?.pessoaFisica
    this.isRepresentantesLegais = this.despacho?.tituloDespacho?.tituloProcessoDTO?.representanteLegais?.length > 0
    this.formOptions.despacho = {
      idProcesso: this.despacho.processo?.id,
      tipo: this.despacho.tipo,
      perfil: this.despacho.perfil
    }
    this.montarTitulo()
    this.$nextTick(() => {
      const fieldDescricao = this.getField('descricaoOrgaoExpedidorOutorgado', 'OUTORGADO')
      if (fieldDescricao) {
        if (this.isOutorgadoPessoaFisica && this.model.orgaoExpedidorOutorgado) {
          const isOutros = this.model.orgaoExpedidorOutorgado === 'OUTROS' ||
                          (this.model.orgaoExpedidorOutorgado && this.model.orgaoExpedidorOutorgado.codigo === 'OUTROS')
          if (isOutros) {
            fieldDescricao.visible = true
            fieldDescricao.required = true
          } else {
            fieldDescricao.visible = false
            fieldDescricao.required = false
            fieldDescricao.disabled = false
          }
        } else {
          fieldDescricao.visible = false
          fieldDescricao.required = false
          fieldDescricao.disabled = false
        }
      }
    })
    this.$nextTick(() => {
      const fieldDescricao = this.getField('descricaoOrgaoExpedidorConjuge', 'CONJUGE')
      if (fieldDescricao) {
        if (this.isConjuge && this.model.orgaoExpedidorConjuge) {
          const isOutros = this.model.orgaoExpedidorConjuge === 'OUTROS' ||
                          (this.model.orgaoExpedidorConjuge && this.model.orgaoExpedidorConjuge.codigo === 'OUTROS')
          if (isOutros) {
            fieldDescricao.visible = true
            fieldDescricao.required = true
          } else {
            fieldDescricao.visible = false
            fieldDescricao.required = false
            fieldDescricao.disabled = false
          }
        } else {
          fieldDescricao.visible = false
          fieldDescricao.required = false
          fieldDescricao.disabled = false
        }
      }
    })
  },

  watch: {
    model: {
      handler: function (val) {
        if (this.isMa) {
          Object.keys(this.model).forEach((key) => {
            if (key === 'textoCertidao') {
              return
            }
            if (typeof this.model[key] === 'string') {
              this.model[key] = this.model[key].toUpperCase()
            }
            if (this.model[key]?.name) {
              this.model[key].name = this.model[key].name.toUpperCase()
            }
            if (['cpfCnpjOutorgado', 'cpfCnpjConjuge'].includes(key)) {
              if (!/^(?:\d{3}\.\d{3}\.\d{3}-\d{2}|\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2})$/.test(this.model[key])) {
                const numeros = String(this.model[key]).replace(/\D/g, '')
                const isCpf = numeros?.length === 11
                const isCnpj = numeros?.length === 14
                if (isCnpj) {
                  this.model[key] = numeros.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5')
                }
                if (isCpf) {
                  this.model[key] = numeros.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4')
                }
              }
            }
          })
        }
      },
      deep: true
    },
    'model.orgaoExpedidorOutorgado': function (val, oldVal) {
      if (val === oldVal) {
        return
      }
      const isOutros = val === 'OUTROS' || (val && val.codigo === 'OUTROS')

      const fieldDescricao = this.getField('descricaoOrgaoExpedidorOutorgado', 'OUTORGADO')

      if (isOutros) {
        if (fieldDescricao) {
          fieldDescricao.visible = true
          fieldDescricao.disabled = false
          fieldDescricao.required = true
        }
      } else {
        if (fieldDescricao) {
          fieldDescricao.visible = false
          fieldDescricao.disabled = false
          fieldDescricao.required = false
        }
        if (oldVal !== null && oldVal !== undefined && oldVal !== '') {
          this.model.descricaoOrgaoExpedidorOutorgado = ''
        }
      }
    },

    'model.comarca': async function (val, oldVal) {
      if (this.isEstadoAP && typeof val === 'string' && this.despacho?.tituloDespacho?.tituloProcessoDTO?.comarca) {
        const municipios = await this.findMunicipiosByUf('AP')
        const municipioSelecionado = municipios.find(m => m.nome === this.despacho.tituloDespacho.tituloProcessoDTO.comarca)
        this.model.comarca = {
          id: municipioSelecionado.id,
          codigo: municipioSelecionado.nome,
          name: municipioSelecionado.nome
        }
      }
    },

    'model.orgaoExpedidorConjuge': function (val, oldVal) {
      if (val === oldVal) {
        return
      }
      const isOutros = val === 'OUTROS' || (val && val.codigo === 'OUTROS')

      const fieldDescricao = this.getField('descricaoOrgaoExpedidorConjuge', 'CONJUGE')

      if (isOutros) {
        if (fieldDescricao) {
          fieldDescricao.visible = true
          fieldDescricao.disabled = false
          fieldDescricao.required = true
        }
      } else {
        if (fieldDescricao) {
          fieldDescricao.visible = false
          fieldDescricao.disabled = false
          fieldDescricao.required = false
        }
        if (oldVal !== null && oldVal !== undefined && oldVal !== '') {
          this.model.descricaoOrgaoExpedidorConjuge = ''
        }
      }
    },
    'model.ufNaturalidadeConjuge': async function (val, oldVal) {
      if (!oldVal && !val) {
        return null
      } else if ((!oldVal && val) || (oldVal.id !== val.id)) {
        const groupConjuge = schemas.emissao_titulo[this.nomeSchema].groups.find(group => group.codigo === 'CONJUGE')
        const fieldMunicipiosConjuge = groupConjuge.fields.find(field => field.inputName === 'naturalidadeConjuge')
        if (!fieldMunicipiosConjuge) {
          return null
        }
        const municipios = await this.findMunicipiosByUf(val.codigo ? val.codigo : val)
        let municipiosList = []
        municipios.forEach((municipio) => {
          const siglaObj = {
            id: municipio.id,
            codigo: municipio.nome,
            name: municipio.nome
          }
          municipiosList.push(siglaObj)
        })
        fieldMunicipiosConjuge.values = municipiosList
        if (oldVal !== undefined) {
          this.model.naturalidadeConjuge = null
        }
      }
    },
    'model.ufNaturalidadeOutorgado': async function (val, oldVal) {
      if (!oldVal && !val) {
        return null
      } else if ((!oldVal && val) || (oldVal.id !== val.id)) {
        const groupConjuge = schemas.emissao_titulo[this.nomeSchema].groups.find(group => group.codigo === 'OUTORGADO')
        const fieldMunicipiosOutorgado = groupConjuge.fields.find(field => field.inputName === 'naturalidadeOutorgado')
        const municipios = await this.findMunicipiosByUf(val.codigo ? val.codigo : val)
        let municipiosList = []
        municipios.forEach((municipio) => {
          const siglaObj = {
            id: municipio.id,
            codigo: municipio.nome,
            name: municipio.nome
          }
          municipiosList.push(siglaObj)
        })
        if (fieldMunicipiosOutorgado) {
          fieldMunicipiosOutorgado.values = municipiosList
        }
        if (oldVal !== undefined) {
          this.model.naturalidadeOutorgado = null
        }
      }
    },
    'model.municipioUfOutorgado': async function (val, oldVal) {
      if (!oldVal && !val) {
        return null
      } else if ((!oldVal && val) || (oldVal.id !== val.id)) {
        const groupConjuge = schemas.emissao_titulo[this.nomeSchema].groups.find(group => group.codigo === 'OUTORGADO')
        const fieldMunicipiosOutorgado = groupConjuge.fields.find(field => field.inputName === 'municipioNomeOutorgado')
        const municipios = await this.findMunicipiosByUf(val.codigo ? val.codigo : val)

        this.municipiosListOutorgado = []
        municipios.forEach((municipio) => {
          const siglaObj = {
            id: municipio.id,
            codigoEstado: municipio.codigoEstado,
            nome: municipio.nome,
            name: municipio.nome
          }
          this.municipiosListOutorgado.push(siglaObj)
        })
        if (fieldMunicipiosOutorgado) {
          fieldMunicipiosOutorgado.values = this.municipiosListOutorgado
        }

        if (oldVal !== undefined) {
          this.model.municipioNomeOutorgado = null
        }
      }
    },
    'model.valorDescontoVtn': async function (val, oldVal) {
      if (!oldVal || !val) {
        return
      }

      this.model.valorTotalVtn = Number(this.model.valorTotalVtn) + val - oldVal
    },
    'model.valorCustasProcessuaisVtn': async function (val, oldVal) {
      if (!oldVal || !val) {
        return
      }

      this.model.valorTotalVtn = Number(this.model.valorTotalVtn) + val - oldVal
    },
    'model.taxaOcupacaoVtn': async function (val, oldVal) {
      if (!oldVal || !val) {
        return
      }

      this.model.valorTotalVtn = Number(this.model.valorTotalVtn) + val - oldVal
    },
    'model.portaria.areaLiquida': async function (val, oldVal) {
      if (oldVal === val) {
        return
      }

      this.model.portaria.areaPorExtenso = this.numeroExtenso(this.model.portaria.areaLiquida, 'hectares')
    },
    'model.faixaDeFronteira': function (val) {
      const groupCaracteristicas = schemas.emissao_titulo[this.nomeSchema].groups[0]
      if (val === 'SIM') {
        if (groupCaracteristicas) {
          groupCaracteristicas.fields.forEach((field) => {
            if (field.model === 'assentimentoPrevio') {
              field.required = true
              field.visible = true
            }
          })
        }
      } else {
        if (groupCaracteristicas) {
          groupCaracteristicas.fields.forEach((field) => {
            if (field.model === 'assentimentoPrevio') {
              field.required = false
              field.visible = false
            }
          })
        }
      }
    }
  },

  computed: {
    isEstadoAP () {
      return process.env.ESTADO === 'ap'
    },
    isEstadMA () {
      return process.env.ESTADO === 'ma'
    },
    isEstadRR () {
      return process.env.ESTADO === 'rr'
    },
    isProcessoMa () {
      return this.tiposProcessoFisico.includes(this.tipo) || this.tipo === 'REURB_INDIVIDUAL'
    },
    isEstadBA () {
      return process.env.ESTADO === 'ba'
    }
  },

  methods: {
    save () {
      if (this.formOptions.validateBeforeSave === false || this.validate()) {
        return this.salvarDespacho()
      } else {
        return undefined
      }
    },
    toUpperCaseHtml (html) {
      if (!this.isEstadMA) {
        return
      }
      const regex = />([^<]+)</g
      const htmlformatado = html?.toLowerCase().replace(regex, (match, p1) => {
        return `>${p1?.toUpperCase()}<`
      })
      return htmlformatado
    },
    checkConjuge () {
      if (this.despacho.tituloDespacho.tituloProcessoDTO.conjuge === null || (this.isProcessoMa && this.despacho.tituloDespacho.tituloProcessoDTO.conjuge?.pessoaFisica?.cpf === null)) {
        const groupConjuge = schemas.emissao_titulo[this.nomeSchema].groups.find(group => group.codigo === 'CONJUGE')
        if (groupConjuge) {
          groupConjuge.fields.forEach((field) => {
            field.required = false
            field.visible = false
          })
        }
      } else {
        if (this.despacho.tituloDespacho.tituloProcessoDTO.outorgado.pessoaFisica?.estadoCivil === 'VIUVO') {
          const groupConjuge = schemas.emissao_titulo[this.nomeSchema].groups.find(group => group.codigo === 'CONJUGE')
          groupConjuge.fields.forEach((field) => {
            if (!['nomeConjuge', 'cpfCnpjConjuge', 'dataNascimentoConjuge', 'profissaoConjuge'].includes(field.model)) {
              field.required = false
              field.visible = false
            }

            if (field.model === 'cpfCnpjConjuge') {
              field.required = false
              field.validator = null
            }
          })
        }
      }
    },
    setLimites () {
      const groupResumoMemorial = schemas.emissao_titulo[this.nomeSchema].groups.find(group => group.codigo === 'RESUMO_MEMORIAL_DESCRITIVO')
      if (groupResumoMemorial?.fields) {
        const fieldLimites = groupResumoMemorial.fields.find(field => field.inputName === 'listagemLimites')
        if (fieldLimites) {
          fieldLimites.values = this.model.portaria ? this.model.portaria.limites : null
        }
      }
    },
    buscaCodigoEstadoCivilConjugeModel () {
      if (this.isMa) {
        return estadoCivil.find(e => e.name.toUpperCase() === this.model.estadoCivilConjuge.toUpperCase() || e.codigo.toUpperCase() === this.model.estadoCivilConjuge.toUpperCase()).codigo
      }
      return estadoCivil.find(e => e.name === this.model.estadoCivilConjuge || e.codigo === this.model.estadoCivilConjuge).codigo
    },
    getConjuge () {
      if (this.despacho.tituloDespacho.tituloProcessoDTO.conjuge !== null) {
        return {
          pessoaJuridica: null,
          email: null,
          endereco: null,
          telefones: [],
          ativo: null,
          tipo: 'PF',
          dataCadastro: null,
          pessoaFisica: {
            cpf: this.model.cpfCnpjConjuge,
            nome: this.model.nomeConjuge,
            rg: this.model.rgConjuge,
            profissao: this.model.profissaoConjuge,
            nacionalidade: this.model.nacionalidadeConjuge ? typeof (this.model.nacionalidadeConjuge) === 'string' ? gentilicos.find(g => g.name.toUpperCase() === this.model.nacionalidadeConjuge?.toUpperCase() || g.codigo === this.model.nacionalidadeConjuge)?.codigo : this.model.nacionalidadeConjuge?.codigo : null,
            estadoCivil: this.model.estadoCivilConjuge ? typeof (this.model.estadoCivilConjuge) === 'string' ? this.buscaCodigoEstadoCivilConjugeModel() : this.model.estadoCivilConjuge.codigo : null,
            tituloEleitor: this.model.tituloEleitorConjuge,
            orgaoExpedidor: {
              codigo: this.model.orgaoExpedidorConjuge ? typeof (this.model.orgaoExpedidorConjuge) === 'string' ? this.model.orgaoExpedidorConjuge : this.model.orgaoExpedidorConjuge.codigo : null,
              estado: this.model.ufRgConjuge ? typeof (this.model.ufRgConjuge) === 'string' ? this.model.ufRgConjuge : this.model.ufRgConjuge.codigo : null
            },
            descricaoOrgaoExpedidor: this.model.descricaoOrgaoExpedidorConjuge,
            dataNascimento: this.model.dataNascimentoConjuge,
            naturalidade: this.model.naturalidadeConjuge ? {
              nome: typeof (this.model.naturalidadeConjuge) === 'string' ? this.model.naturalidadeConjuge : this.model.naturalidadeConjuge.name,
              codigoEstado: typeof (this.model.ufNaturalidadeConjuge) === 'string' ? this.model.ufNaturalidadeConjuge : this.model.ufNaturalidadeConjuge.codigo
            } : null
          }
        }
      } else {
        return null
      }
    },

    getMomentToDate (date) {
      if (!moment(date).isValid()) {
        return null
      }
      return moment(date).toDate()
    },

    async getMunicipio (endereco) {
      if (!endereco || !endereco.municipio || (!endereco.municipio.id && !endereco.municipio.codigoEstado)) return null

      if (endereco.municipio.id) {
        return endereco.municipio
      }

      const municipios = await this.findMunicipiosByUf(endereco.municipio.codigoEstado)
      const municipio = municipios.find(item => item.nome === endereco.municipio.nome)

      return municipio
    },

    getOutorgado () {
      if (this.isOutorgadoPessoaFisica) {
        return {
          pessoaJuridica: null,
          email: null,
          ativo: null,
          tipo: 'PF',
          dataCadastro: null,
          pessoaFisica: {
            cpf: this.model.cpfCnpjOutorgado,
            nome: this.model.nomeOutorgado,
            rg: this.model.rgOutorgado,
            nacionalidade: this.model.nacionalidadeOutorgado ? typeof (this.model.nacionalidadeOutorgado) === 'string' ? gentilicos.find(g => g.name.toUpperCase() === this.model.nacionalidadeOutorgado.toUpperCase() || g.codigo === this.model.nacionalidadeOutorgado)?.codigo : this.model.nacionalidadeOutorgado?.codigo : null,
            estadoCivil: this.model.estadoCivilOutorgado ? typeof (this.model.estadoCivilOutorgado) === 'string' ? estadoCivil.find(e => e.name.toUpperCase() === this.model.estadoCivilOutorgado.toUpperCase() || e.codigo === this.model.estadoCivilOutorgado)?.codigo : this.model.estadoCivilOutorgado?.codigo : null,
            regimeCasamento: this.model.regimeCasamento,
            tituloEleitor: this.model.tituloEleitorOutorgado,
            profissao: this.model.profissao,
            dataCasamento: this.model.dataCasamento,
            orgaoExpedidor: {
              codigo: this.model.orgaoExpedidorOutorgado ? typeof (this.model.orgaoExpedidorOutorgado) === 'string' ? this.model.orgaoExpedidorOutorgado : this.model.orgaoExpedidorOutorgado.codigo : null,
              estado: this.model.ufRgOutorgado ? typeof (this.model.ufRgOutorgado) === 'string' ? this.model.ufRgOutorgado : this.model.ufRgOutorgado.codigo : null
            },
            descricaoOrgaoExpedidor: this.model.descricaoOrgaoExpedidorOutorgado,
            dataNascimento: this.model.dataNascimentoOutorgado,
            naturalidade: this.model.naturalidadeOutorgado ? {
              nome: typeof (this.model.naturalidadeOutorgado) === 'string' ? this.model.naturalidadeOutorgado : this.model.naturalidadeOutorgado.name,
              codigoEstado: typeof (this.model.ufNaturalidadeOutorgado) === 'string' ? this.model.ufNaturalidadeOutorgado : this.model.ufNaturalidadeOutorgado.codigo
            } : null
          }
        }
      } else {
        const municipio = this.municipiosListOutorgado.find(item => item.id === this.model.municipioNomeOutorgado.id)
        return {
          endereco: {
            municipio: {
              ...municipio
            },
            logradouro: this.model.logradouroOutorgado,
            numero: this.model.numeroOutorgado === '-' ? null : this.model.numeroOutorgado,
            complemento: this.model.complementoOutorgado,
            bairro: this.model.bairroOutorgado
          },
          pessoaJuridica: {
            inscricaoEstadual: this.model.inscricaoEstadualOutorgado,
            razaoSocial: this.model.nomeOutorgado,
            cnpj: this.model.cpfCnpjOutorgado
          }
        }
      }
    },

    removeValoresNulos (obj) {
      const newObj = {}
      for (const key in obj) {
        if (obj[key]) {
          newObj[key] = obj[key]
        }
      }
      return newObj
    },

    getEspecie () {
      if (this.isEstadMA) {
        if (this.model.especie.id === 'Outros') {
          return this.model.descricao
        }
        return this.model.especie ? (this.model.especie.id ? this.model.especie.id : this.model.especie) : ''
      } else {
        return this.model.especie
      }
    },

    salvarDespacho () {
      let despacho = this.despacho
      if (this.isEstadMA && this.isRetificacaoTitulo) {
        despacho.tituloDespacho.tituloProcessoDTO = {
          ...JSON.parse(despacho.tituloDespacho.tituloProcesso),
          assinaturas: null,
          isAssinadoPresidente: false,
          isRodaPe: false,
          especie: this.getEspecie(),
          numeroTitulo: this.model.numeroTitulo,
          dataEmissao: this.model.dataEmissao,
          ufEmissao: this.model.ufEmissao,
          textoCertidao: this.model.textoCertidao,
          outorgante: this.model.outorgante,
          numeroProcesso: this.model.numeroProcesso,
          codigoImovel: this.model.portaria.codigoImovel,
          gleba: this.model.gleba,
          proprietario: this.model.proprietario,
          numeroFolha: this.model.numeroFolha,
          numeroLivro: this.model.numeroLivro,
          municipioEmissao: this.model.municipioEmissao,
          municipio: this.despacho.tituloDespacho.tituloProcessoDTO.municipio,
          responsavelTecnico: this.model.responsavelTecnico,
          outorgado: this.getOutorgado(),
          conjuge: this.getConjuge(),
          enderecoImovel: this.model.enderecoImovel,
          latitude: this.model.latitude,
          longitude: this.model.longitude,
          nomeImovel: this.model.nomeImovel,
          glebaImovel: this.model.glebaImovel,
          areaImovel: this.model.areaImovel,
          logradouroImovel: this.model.logradouroImovel,
          numeroImovel: this.model.numeroImovel,
          bairroImovel: this.model.bairroImovel,
          municipioImovel: this.model.municipioImovel?.name ? this.model.municipioImovel.name : this.model.municipioImovel,
          precoImovel: this.model.precoImovel
        }
      } else {
        despacho.tituloDespacho.tituloProcessoDTO = {
          camposEditaveis: this.despacho.tituloDespacho.tituloProcessoDTO.camposEditaveis,
          doe: this.despacho.tituloDespacho.tituloProcessoDTO.doe,
          dataPublicacaoDoe: this.despacho.tituloDespacho.tituloProcessoDTO.dataPublicacaoDoe,
          textoCertidao: this.model.textoCertidao,
          ufEmissao: this.model.ufEmissao,
          dataEmissao: this.model.dataEmissao,
          outorgante: this.model.outorgante,
          codigoImovel: this.model.portaria.codigoImovel,
          gleba: this.model.gleba,
          proprietario: this.model.proprietario,
          numeroFolha: this.model.numeroFolha,
          numeroLivro: this.model.numeroLivro,
          numeroTitulo: this.model.numeroTitulo,
          norte: this.model.norte,
          sul: this.model.sul,
          leste: this.model.leste,
          oeste: this.model.oeste,
          municipioEmissao: this.model.municipioEmissao,
          municipio: this.despacho.tituloDespacho.tituloProcessoDTO.municipio,
          responsavelTecnico: this.model.responsavelTecnico,
          especie: this.getEspecie(),
          outorgado: this.getOutorgado(),
          conjuge: this.getConjuge(),
          finalidade: this.model?.finalidade?.codigo,
          numeroProcesso: this.model.numeroProcesso,
          formaPoligono: this.model.formaPoligono,
          enderecoImovel: this.model.enderecoImovel,
          testada: this.model.testada,
          tipoCoordenada: this.model.tipoCoordenada,
          lados: this.model.lados,
          representanteLegais: this.model.representanteLegais ? this.model.representanteLegais.map(item => ({
            ...item,
            pessoa: {
              ...item.pessoa,
              pessoaFisica: {
                ...item.pessoa.pessoaFisica,
                naturalidade: {
                  codigoEstado: item?.pessoa?.pessoaFisica?.naturalidade?.codigoEstado?.codigo ? item?.pessoa?.pessoaFisica?.naturalidade?.codigoEstado?.codigo : item?.pessoa?.pessoaFisica?.naturalidade?.codigoEstado,
                  nome: item?.pessoa?.pessoaFisica?.naturalidade?.nome?.name ? item?.pessoa?.pessoaFisica?.naturalidade?.nome?.name : item?.pessoa?.pessoaFisica?.naturalidade?.nome
                },
                estadoCivil: item?.pessoa?.pessoaFisica?.estadoCivil?.codigo,
                nacionalidade: item?.pessoa?.pessoaFisica?.nacionalidade?.codigo,
                orgaoExpedidor: {
                  nomeEstado: item.pessoa.pessoaFisica.orgaoExpedidor?.nomeEstado?.codigo ? item.pessoa.pessoaFisica.orgaoExpedidor.nomeEstado.codigo : item.pessoa?.pessoaFisica?.orgaoExpedidor?.nomeEstado,
                  nome: item.pessoa.pessoaFisica.orgaoExpedidor?.nome?.name ? item?.pessoa?.pessoaFisica?.orgaoExpedidor?.nome?.name : item?.pessoa?.pessoaFisica?.orgaoExpedidor?.nome,
                  id: item.pessoa.pessoaFisica.orgaoExpedidor?.nome?.id ? item?.pessoa?.pessoaFisica?.orgaoExpedidor?.codigo?.id : item?.pessoa?.pessoaFisica?.orgaoExpedidor?.id,
                  codigo: item.pessoa.pessoaFisica.orgaoExpedidor?.nome?.codigo ? item?.pessoa?.pessoaFisica?.orgaoExpedidor?.nome?.codigo : item?.pessoa?.pessoaFisica?.orgaoExpedidor?.codigo
                }
              }
            }
          })) : null,
          registro: this.model.registro,
          comarca: this.model.comarca?.codigo ? this.model.comarca?.codigo : this.model.comarca,
          oficio: this.model.oficio,
          portaria: this.despacho.portaria ? {
            codigoImovel: this.model.portaria.codigoImovel,
            numeroModuloFiscal: this.model.portaria.numeroModuloFiscal,
            localizacao: this.model.portaria.localizacao,
            numeroCadastroMunicipal: this.model.portaria.numeroCadastroMunicipal,
            municipio: {
              nome: this.isEstadoAP ? this.model.municipio.nome : this.model.portaria.municipio.nome,
              codigoEstado: this.isEstadoAP ? this.model.municipio.codigoEstado : this.model.portaria.municipio.codigoEstado
            },
            denominacao: this.model.portaria.denominacao,
            perimetro: this.model.portaria.perimetro,
            areaLiquida: parseInt(this.model.portaria.areaLiquida),
            declinacaoMagnetica: this.model.portaria.declinacaoMagnetica,
            data: this.despacho.portaria.data,
            numero: this.model.portaria.numero,
            limites: this.model.portaria.limites,
            memorialDescritivo: this.model.portaria.memorialDescritivo !== null ? this.model.portaria.memorialDescritivo.replace(/<br>/g, '<br/>') : '',
            areaTotal: this.model.portaria.areaTotal,
            numeroPorta: this.model.portaria.numeroPorta,
            mesAnoMedicao: this.model.portaria.mesAnoMedicao,
            dadosParcela: this.model.portaria.dadosParcela,
            municipios: this.model.portaria.municipios,
            numeroPublicacaoPortaria: this.despacho.tituloDespacho?.tituloProcessoDTO?.numeroPublicacaoPortaria || '',
            confrontantes: this.model.portaria?.confrontantes,
            numeroSei: this.model?.portaria?.numeroSei
          } : {
            codigoImovel: this.model?.portaria?.codigoImovel,
            numeroModuloFiscal: this.model?.portaria?.numeroModuloFiscal,
            localizacao: this.model?.portaria?.localizacao,
            numeroCadastroMunicipal: this.model?.portaria?.numeroCadastroMunicipal,
            perimetro: this.model?.portaria?.perimetro ? `${this.model?.portaria?.perimetro}`.replace(',', '.') : '',
            denominacao: this.model?.portaria?.denominacao,
            declinacaoMagnetica: this.model?.portaria?.declinacaoMagnetica,
            memorialDescritivo: this.model?.portaria?.memorialDescritivo !== null ? this.model?.portaria?.memorialDescritivo.replace(/<br>/g, '<br/>') : '',
            areaTotal: this.model?.portaria?.areaTotal ? `${this.model?.portaria?.areaTotal}`.replace(',', '.') : '',
            areaLiquida: this.model?.portaria?.areaLiquida ? `${this.model?.portaria?.areaLiquida}`.replace(',', '.') : '',
            numeroPorta: this.model?.portaria?.numeroPorta,
            mesAnoMedicao: this.model?.portaria?.mesAnoMedicao,
            dadosParcela: this.model?.portaria?.dadosParcela,
            municipios: this.model?.portaria?.municipios,
            municipio: this.model?.portaria?.municipio,
            limites: this.model?.portaria?.limites,
            numeroPublicacaoPortaria: this.despacho.tituloDespacho?.tituloProcessoDTO?.numeroPublicacaoPortaria || '',
            confrontantes: this.model.portaria?.confrontantes,
            numeroSei: this.model.portaria?.numeroSei
          },
          homologacaoSentenca: this.model.homologacaoSentenca,
          informacoesRegistro: this.model.informacoesRegistro !== null ? this.model.informacoesRegistro.replace(/<br>/g, '<br/>') : '',
          totalJuros: (this.isEstadBA)
            ? this.despacho.tituloDespacho.tituloProcessoDTO.totalJuros
            : this.model.totalJuros
              .replace('R$', '')
              .replaceAll('.', '')
              .replace(',', '.'),
          valorVtn: this.isEstadoAP ? this.despacho.tituloDespacho.tituloProcessoDTO.valorVtn : this.model.valorVtn,
          valorFinalAposCarencia: this.model.valorFinalAposCarencia,
          prazoCarencia: this.model.prazoCarencia,
          carenciaVtn: this.model.carenciaVtn,
          valorPrestacao: this.model.valorPrestacao,
          correcaoAnual: this.model.correcaoAnual,
          taxaJurosAnual: this.model.taxaJurosAnual,
          valorTotalVtn: this.isEstadoAP ? Number(
            this.model.valorTotalVtn
              .replace('R$', '')
              .replaceAll('.', '')
              .replace(',', '.')
          ) : this.model.valorTotalVtn,
          valorPorcentagemDescontoVtn: this.model.valorPorcentagemDescontoVtn,
          valorDescontoVtn: this.model.valorDescontoVtn,
          valorCustasAgrariasVtn: this.model.valorCustasAgrariasVtn,
          valorCustasProcessuaisVtn: this.model.valorCustasProcessuaisVtn,
          taxaOcupacaoVtn: this.model.taxaOcupacaoVtn,
          vtnParcelado: this.model.vtnParcelado,
          valorEntradaVtn: this.model.valorEntradaVtn,
          porcentagemEntradaVtn: this.model.porcentagemEntradaVtn,
          quantidadeDeParcelas: this.model.quantidadeDeParcelas,
          valorParcelasRestantes: this.model.valorParcelasRestantes,
          vencimentoProximaParcela: this.model.vencimentoProximaParcela,
          embasamentoJuridico: this.model.embasamentoJuridico !== null ? this.model.embasamentoJuridico.replace(/<br>/g, '<br/>') : '',
          latitude: this.model.latitude,
          longitude: this.model.longitude,
          nomeImovel: this.model.nomeImovel,
          glebaImovel: this.model.glebaImovel,
          areaImovel: this.model.areaImovel,
          logradouroImovel: this.model.logradouroImovel,
          numeroImovel: this.model.numeroImovel,
          bairroImovel: this.model.bairroImovel,
          municipioImovel: this.model.municipioImovel?.name ? this.model.municipioImovel.name : this.model.municipioImovel,
          quadraDeControle: this.model.quadraDeControle,
          numeroDeControle: this.model.numeroDeControle,
          precoImovel: this.model.precoImovel,
          matRegTrans: this.model.matRegTrans,
          cns: this.model.cns,
          tipoProcesso: this.isEstadoAP ? this.model.tipoProcesso : this.despacho?.processo?.tipo?.codigo,
          condicaoPagamento: this.model.condicaoPagamento,
          valorPrimeiraParcela: this.isEstadBA
            ? this.despacho.tituloDespacho.tituloProcessoDTO?.valorPrestacao
            : this.model.valorPrimeiraParcela
              .replace('R$', '')
              .replaceAll('.', '')
              .replace(',', '.'),
          vencimentoPrimeiraParcela: this.model.vencimentoPrimeiraParcela,
          vtnPrazoInalienabilidade: this.model.vtnPrazoInalienabilidade
        }
      }

      if (this.despacho.tituloDespacho?.tituloProcessoDTO?.numeroPublicacaoPortaria) {
        despacho.portaria.numeroPublicacaoPortaria = this.despacho.tituloDespacho?.tituloProcessoDTO?.numeroPublicacaoPortaria
      }

      despacho.tituloDespacho.tituloProcessoDTO = {
        ...despacho.tituloDespacho.tituloProcessoDTO,
        representanteLegais: despacho.tituloDespacho.tituloProcessoDTO.representanteLegais ? despacho.tituloDespacho.tituloProcessoDTO.representanteLegais.map(item => ({
          ...item,
          conjuge: item.conjuge !== null ? {
            ...item.conjuge,
            pessoaFisica: {
              ...item.conjuge.pessoaFisica,
              orgaoExpedidor: {
                id: item?.conjuge?.pessoaFisica?.orgaoExpedidor?.nome?.id ? item?.conjuge?.pessoaFisica?.orgaoExpedidor?.nome?.id : item?.conjuge?.pessoaFisica?.orgaoExpedidor?.id,
                nomeEstado: item?.conjuge?.pessoaFisica?.orgaoExpedidor?.nomeEstado?.codigo ? item?.conjuge?.pessoaFisica?.orgaoExpedidor?.nomeEstado?.codigo : item?.conjuge?.pessoaFisica?.orgaoExpedidor?.nomeEstado,
                nome: item?.conjuge?.pessoaFisica?.orgaoExpedidor?.nome?.name ? item?.conjuge?.pessoaFisica?.orgaoExpedidor?.nome?.name : item?.conjuge?.pessoaFisica?.orgaoExpedidor?.nome,
                codigo: item?.conjuge?.pessoaFisica?.orgaoExpedidor?.nome?.codigo ? item?.conjuge?.pessoaFisica?.orgaoExpedidor?.nome?.codigo : item?.conjuge?.pessoaFisica?.orgaoExpedidor?.codigo
              },
              naturalidade: {
                codigoEstado: item?.conjuge?.pessoaFisica?.naturalidade?.codigoEstado?.codigo ? item?.conjuge?.pessoaFisica?.naturalidade?.codigoEstado?.codigo : item?.conjuge?.pessoaFisica?.naturalidade?.codigoEstado,
                nome: item?.conjuge?.pessoaFisica?.naturalidade?.nome?.name ? item?.conjuge?.pessoaFisica?.naturalidade?.nome?.name : item?.conjuge?.pessoaFisica?.naturalidade?.nome
              },
              nacionalidade: item?.conjuge?.pessoaFisica?.nacionalidade?.codigo ? item?.conjuge?.pessoaFisica?.nacionalidade?.codigo : item?.conjuge?.pessoaFisica?.nacionalidade
            }
          } : null
        })) : null
      }
      // campos rr
      if (this.isEstadRR) {
        const camposRR = {
          faixaDeFronteira: this.model.faixaDeFronteira.codigo,
          assentimentoPrevio: this.model.assentimentoPrevio,
          sncr: this.model.sncr,
          sigef: this.model.sigef,
          matricula: this.model.matricula,
          frequenciaPagamento: this.model.frequenciaPagamento,
          indiceCorrecao: this.model.indiceCorrecao,
          valorVtnImovel: this.model.valorVtnImovel,
          valorVtnImovelAVista: this.model.valorVtnImovelAVista,
          valorMinimoVtn: this.model.valorMinimoVtn,
          valorVtntReserva: this.model.valorVtntReserva,
          valorVtntArea: this.model.valorVtntArea
        }
        despacho.tituloDespacho.tituloProcessoDTO = {...despacho.tituloDespacho.tituloProcessoDTO, ...camposRR}
      } else if (this.isEstadMA) {
        const camposMA = {
          matriculaImovel: this.model.matriculaImovel,
          livroMatriculaImovel: this.model.livroMatriculaImovel,
          folhaMatriculaImovel: this.model.folhaMatriculaImovel,
          municipioMatriculaImovel: this.model.municipioMatriculaImovel?.name ? this.model.municipioMatriculaImovel.name : this.model.municipioMatriculaImovel,
          cartorioMatriculaImovel: this.model.cartorioMatriculaImovel,
          numeroDeControle: this.model.numeroDeControle,
          quadraDeControle: this.model.quadraDeControle,
          isRetificacaoTitulo: this.isRetificacaoTitulo
        }
        despacho.tituloDespacho.tituloProcessoDTO = {...despacho.tituloDespacho.tituloProcessoDTO, ...camposMA}
      } else if (this.isEstadoAP) {
        const camposAP = {
          faixaDeFronteira: this.model.faixaDeFronteira,
          assentimentoPrevio: this.model.assentimentoPrevio
        }
        despacho.tituloDespacho.tituloProcessoDTO = {...despacho.tituloDespacho.tituloProcessoDTO, ...camposAP}
      }
      this.despacho.tituloDespacho.tituloProcesso = JSON.stringify(despacho.tituloDespacho.tituloProcessoDTO)
      return despacho
    },

    validate () {
      return this.$refs.form.validate()
    },

    ...mapActions({
      findMunicipiosByUf: 'municipios/findMunicipiosByUf',
      getVtnByIdProcesso: 'vtn/getVtnbyIdProcesso',
      getDespachoDadosImovel: 'despacho/getDespachoDadosImovel',
      getProcessoWithCadastro: 'processos/getProcessoByProtocolo'
    }),
    onValidate: function ($event) {
      this.$refs.vfg.validate()
    },

    numeroExtenso (numero, tipo) {
      const novoNumero = typeof numero === 'string' ? Number(numero.replace(',', '.')) : numero
      if (novoNumero > 0 && novoNumero < 1) return utils.decimalPorExtenso(novoNumero, tipo)
      else if (numero) {
        return utils.converteNumeroExtenso(numero, tipo)
      } else {
        return null
      }
    },

    async setDadosCadastroErrataTitulo () {
      if (this.despacho?.processo?.numeroProtocolo) {
        const response = await this.getProcessoWithCadastro(this.despacho.processo.numeroProtocolo)
        if (!this.model.outorgante) {
          this.model.outorgante = 'INSTITUTO DE COLONIZAÇÃO E TERRAS DO MARANHÃO'
        }
        if (!this.model.nomeOutorgado) {
          this.model.nomeOutorgado = response?.dadosCadastro?.dados?.cadastro?.interessado?.pessoa?.pessoaFisica?.nome
        }
        if (!this.model.cpfCnpjOutorgado) {
          this.model.cpfCnpjOutorgado = response?.dadosCadastro?.dados?.cadastro?.interessado?.pessoa?.pessoaFisica?.cpf
        }
        if (!this.model.areaImovel) {
          this.model.areaImovel = response?.dadosCadastro?.dados?.cadastro?.imovel?.area
        }
        if (!this.model.nomeImovel) {
          this.model.nomeImovel = response?.dadosCadastro?.dados?.cadastro?.imovel?.nome
        }
        if (!this.model.municipioImovel) {
          this.model.municipioImovel = response?.dadosCadastro?.dados?.cadastro?.imovel?.municipio?.nome
        }
        if (!this.model.numeroFolha) {
          this.model.numeroFolha = this.despacho?.tituloDespacho?.tituloProcessoDTO?.numeroLivro
        }
      }
    },

    getFaixaFronteira (codigo) {
      if (!codigo) return null

      if (this.isAp) return codigo

      const listaFaixaFronteira = [
        { id: 0, codigo: 'SIM', name: 'Sim' },
        { id: 1, codigo: 'NAO', name: 'Não' }
      ]

      return listaFaixaFronteira.find(faixa => faixa.codigo === codigo)
    },

    north () {
      return this.despacho.portaria.memorialDescritivo && this.despacho.tituloDespacho.tituloProcessoDTO.portaria.memorialDescritivo.split(';').length > 1 ? this.despacho.portaria.memorialDescritivo.split(';')[0].match(/(\N\ {0,})(=\ {0,})((\d{1,3}\.)((\d{3}\.)*)(\d{3},\d{0,4}\m))/g)[0].split(' =')[1] : '';// eslint-disable-line
    },

    east () {
      return this.despacho.portaria.memorialDescritivo && this.despacho.tituloDespacho.tituloProcessoDTO.portaria.memorialDescritivo.split(';').length > 1 ? this.despacho.portaria.memorialDescritivo.split(';')[0].match(/(\E\ {0,})(=\ {0,})((\d{1,3}\.)((\d{3}\.)*)(\d{3},\d{0,4}\m))/g)[0].split(' =')[1] : '';// eslint-disable-line
    },

    portariaFormatado () {
      return 'PORTARIA Nº' + this.despacho.portaria.numero + ' DE ' + moment(this.despacho.portaria.data).format('DD/MM/YYYY')
    },

    doeFormatado () {
      if (this.despacho.tituloDespacho.tituloProcessoDTO.doe) {
        return 'D.O.E.Nº' + this.despacho.tituloDespacho.tituloProcessoDTO.doe + ' DE ' + moment(this.despacho.tituloDespacho.tituloProcessoDTO.dataPublicacaoDoe).format('DD/MM/YYYY')
      } else if (this.despacho.tituloDespacho.tituloProcessoDTO.numeroPublicacaoPortaria) {
        return 'Nº Publicação de portaria ' + this.despacho.tituloDespacho.tituloProcessoDTO.numeroPublicacaoPortaria + ' DE ' + moment(this.despacho.tituloDespacho.tituloProcessoDTO.dataPublicacaoDoe).format('DD/MM/YYYY')
      }
    },

    getOutorgante () {
      switch (this.tipo) {
        case 'REGULARIZACAO_URBANA':
          return 'MUNICÍPIO DE MARITUBA EM PARCERIA COM GOVERNO DO ESTADO DO PARÁ'
        default:
          return this.despacho.tituloDespacho.tituloProcessoDTO.outorgante
      }
    },

    nacionalidadeOutorgado () {
      switch (this.tipo) {
        case 'REGULARIZACAO_URBANA':
          return this.despacho?.tituloDespacho?.tituloProcessoDTO?.outorgado?.pessoaFisica?.gentilico ? this.despacho.tituloDespacho.tituloProcessoDTO.outorgado.pessoaFisica.gentilico : gentilicos.find(g => g.codigo === 'BR')
        default:
          return this.despacho?.tituloDespacho?.tituloProcessoDTO?.outorgado?.pessoaFisica ? this.despacho.tituloDespacho.tituloProcessoDTO.outorgado.pessoaFisica.gentilico : null
      }
    },

    localizacaoImovel () {
      return this.despacho?.portaria?.localizacao ? this.despacho.portaria.localizacao.toUpperCase() : ''
    },

    municipioImovel () {
      return this.despacho.portaria && this.despacho.portaria.municipiosFormatadoNome ? this.despacho.portaria.municipiosFormatadoNome.toUpperCase() : null
    },

    ufImovel () {
      return this.despacho.portaria && this.despacho.portaria.municipios?.length > 0 ? this.despacho.portaria.municipios[0].codigoEstado : null
    },

    denominacaoImovel () {
      return this.despacho.portaria && this.despacho.portaria.denominacao ? this.despacho.portaria.denominacao.toUpperCase() : null
    },

    perimetroGeral () {
      return this.despacho.portaria ? this.despacho.portaria.perimetro : null
    },

    declinacao () {
      return this.despacho.portaria.declinacaoMagnetica ? this.despacho.portaria.declinacaoMagnetica.toUpperCase() : null
    },

    dataMedicao () {
      return moment(this.despacho.portaria.data).format('MM/YYYY')
    },

    naturezaFormatada () {
      return ({
        NAO_ONEROSO: 'ALIENAÇÃO NÃO ONEROSA',
        PEAEX: 'DIREITO REAL DE USO',
        ONEROSO: 'ALIENAÇÃO ONEROSA',
        REGULARIZACAO_URBANA: 'NÃO ONEROSA (GRATUITA)',
        TEQ: 'ALIENAÇÃO DE TERRITÓRIO ESTADUAL QUILOMBOLA (TEQ)'
      }[this.tipo] || '-')
    },

    getDataEmissao () {
      switch (this.tipo) {
        case 'REGULARIZACAO_URBANA':
          return new Date()
        default:
          return moment(this.despacho.tituloDespacho.tituloProcessoDTO.dataEmissao).toDate()
      }
    },

    mountOrgaoExpedidor () {
      var retorno = null
      if (this.despacho.tituloDespacho.tituloProcessoDTO.conjuge) {
        if (this.despacho.tituloDespacho.tituloProcessoDTO.conjuge?.pessoaFisica?.orgaoExpedidor) {
          retorno = this.despacho.tituloDespacho.tituloProcessoDTO.conjuge?.pessoaFisica?.orgaoExpedidor.codigo
        }
      }
      return retorno
    },

    getEspecieRetificacao () {
      const especiesTitulo = [
        'Título de Domínio',
        'TÍTULO DE DOMÍNIO',
        'Título de Reconhecimento de Domínio',
        'TÍTULO DE RECONHECIMENTO DE DOMÍNIO',
        'Título de Domínio Comunitário',
        'TÍTULO DE DOMÍNIO COMUNITARIO'
      ]
      if (especiesTitulo.includes(this.despacho.tituloDespacho.tituloProcessoDTO.especie)) {
        return 'Errata de Título'
      }
      return this.despacho.tituloDespacho.tituloProcessoDTO.especie
    },

    async montarTitulo () {
      this.model = {
        tipoProcesso: (this.isEstadoAP && this.despacho.tituloDespacho.tituloProcessoDTO.alienacaoDinamica)
          ? this.despacho.tituloDespacho.tituloProcessoDTO.alienacaoDinamica
          : this.despacho?.processo?.tipo?.nome,
        finalidade: this.despacho?.tituloDespacho?.tituloProcessoDTO?.finalidade ? finalidade.find(e => e.codigo === this.despacho?.tituloDespacho?.tituloProcessoDTO?.finalidade) : null,
        numeroTitulo: this.despacho.tituloDespacho.tituloProcessoDTO.numeroTitulo,
        numeroFolha: this.despacho.tituloDespacho.tituloProcessoDTO.numeroFolha,
        textoCertidao: this.despacho.tituloDespacho.tituloProcessoDTO.textoCertidao,
        numeroLivro: this.despacho.tituloDespacho.tituloProcessoDTO.numeroLivro,
        especie: this.isRetificacaoTitulo ? this.getEspecieRetificacao() : this.despacho.tituloDespacho.tituloProcessoDTO.especie,
        municipioEmissao: this.despacho.tituloDespacho.tituloProcessoDTO.municipioEmissao,
        municipio: this.despacho.tituloDespacho.tituloProcessoDTO.municipio,
        outorgante: this.despacho.tituloDespacho.tituloProcessoDTO.outorgante,
        ufEmissao: this.despacho.tituloDespacho.tituloProcessoDTO.ufEmissao,
        nomeOutorgado: this.isOutorgadoPessoaFisica ? this.despacho.tituloDespacho.tituloProcessoDTO.outorgado.pessoaFisica.nome : this.despacho?.tituloDespacho?.tituloProcessoDTO?.outorgado?.pessoaJuridica?.razaoSocial,
        nacionalidadeOutorgado: this.nacionalidadeOutorgado(),
        estadoCivilOutorgado: this.isOutorgadoPessoaFisica && this.despacho.tituloDespacho.tituloProcessoDTO.outorgado.pessoaFisica.estadoCivil ? estadoCivil.find(e => e.codigo === this.despacho.tituloDespacho.tituloProcessoDTO.outorgado.pessoaFisica.estadoCivil).name : null,
        rgOutorgado: this.isOutorgadoPessoaFisica ? this.despacho.tituloDespacho.tituloProcessoDTO.outorgado.pessoaFisica.rg : null,
        orgaoExpedidorOutorgado: this.isOutorgadoPessoaFisica ? this.despacho.tituloDespacho.tituloProcessoDTO.outorgado.pessoaFisica?.orgaoExpedidor?.codigo : null,
        descricaoOrgaoExpedidorOutorgado: this.isOutorgadoPessoaFisica ? this.despacho.tituloDespacho.tituloProcessoDTO.outorgado.pessoaFisica?.descricaoOrgaoExpedidor : null,
        ufRgOutorgado: this.isOutorgadoPessoaFisica ? this.despacho.tituloDespacho.tituloProcessoDTO.outorgado.pessoaFisica?.orgaoExpedidor?.estado : null,
        cpfCnpjOutorgado: this.isOutorgadoPessoaFisica ? this.despacho.tituloDespacho.tituloProcessoDTO.outorgado.pessoaFisica.cpf : this.despacho.tituloDespacho.tituloProcessoDTO.outorgado?.pessoaJuridica?.cnpj,
        representanteLegais: this.despacho?.tituloDespacho?.tituloProcessoDTO?.representanteLegais?.map((e) => ({
          ...e,
          pessoa: {
            ...e.pessoa,
            pessoaFisica: {
              ...e.pessoa.pessoaFisica,
              naturalidade: {
                codigoEstado: e?.pessoa?.pessoaFisica?.naturalidade?.codigoEstado,
                nome: e?.pessoa?.pessoaFisica?.naturalidade?.nome
              },
              orgaoExpedidor: {
                nomeEstado: e?.pessoa?.pessoaFisica?.orgaoExpedidor?.nomeEstado,
                nome: e?.pessoa?.pessoaFisica?.orgaoExpedidor?.nome,
                codigo: e?.pessoa?.pessoaFisica?.orgaoExpedidor?.codigo
              },
              nacionalidade: {
                codigo: e?.pessoa?.pessoaFisica?.nacionalidade,
                nome: e?.pessoa?.pessoaFisica?.gentilico
              },
              estadoCivil: {
                codigo: e?.pessoa?.pessoaFisica?.estadoCivil,
                nome: e?.pessoa?.pessoaFisica?.estadoCivil?.nome
              }
            }
          },
          ...e.conjuge !== null ? {
            conjuge: {
              ...e.conjuge,
              pessoaFisica: {
                ...e.conjuge.pessoaFisica,
                nacionalidade: {
                  nome: e?.conjuge?.pessoaFisica?.gentilico,
                  codigo: e?.conjuge?.pessoaFisica?.nacionalidade
                },
                orgaoExpedidor: {
                  nomeEstado: e?.conjuge?.pessoaFisica?.orgaoExpedidor?.nomeEstado,
                  nome: e?.conjuge?.pessoaFisica?.orgaoExpedidor?.nome,
                  codigo: e?.conjuge?.pessoaFisica?.orgaoExpedidor?.codigo
                },
                naturalidade: {
                  codigoEstado: e?.conjuge?.pessoaFisica?.naturalidade?.codigoEstado,
                  nome: e?.conjuge?.pessoaFisica?.naturalidade?.nome
                }
              }
            }
          } : {}
        })),
        registro: this.despacho.tituloDespacho.tituloProcessoDTO.registro ? this.despacho.tituloDespacho.tituloProcessoDTO.registro : null,
        oficio: this.despacho.tituloDespacho.tituloProcessoDTO.oficio ? this.despacho.tituloDespacho.tituloProcessoDTO.oficio : null,
        profissao: this.isOutorgadoPessoaFisica ? this.despacho.tituloDespacho.tituloProcessoDTO.outorgado.pessoaFisica.profissao : null,
        tituloEleitorOutorgado: this.isOutorgadoPessoaFisica ? this.despacho.tituloDespacho.tituloProcessoDTO.outorgado.pessoaFisica.tituloEleitor : null,
        comarca: this.despacho.tituloDespacho.tituloProcessoDTO.comarca,
        tituloEleitorConjuge: this.despacho.tituloDespacho.tituloProcessoDTO.conjuge ? this.despacho.tituloDespacho.tituloProcessoDTO.conjuge?.pessoaFisica?.tituloEleitor : null,
        regimeCasamento: this.isOutorgadoPessoaFisica ? this.despacho.tituloDespacho.tituloProcessoDTO.outorgado.pessoaFisica.regimeCasamento : null,
        dataCasamento: this.isOutorgadoPessoaFisica ? this.despacho.tituloDespacho.tituloProcessoDTO.outorgado.pessoaFisica.dataCasamento : null,
        // -----
        dataNascimentoOutorgado: this.isOutorgadoPessoaFisica ? this.despacho.tituloDespacho.tituloProcessoDTO.outorgado.pessoaFisica.dataNascimento ? moment(this.despacho.tituloDespacho.tituloProcessoDTO.outorgado.pessoaFisica.dataNascimento).toDate() : null : null,
        dataNascimentoConjuge: this.despacho.tituloDespacho.tituloProcessoDTO.conjuge ? this.despacho.tituloDespacho.tituloProcessoDTO.conjuge?.pessoaFisica?.dataNascimento ? moment(this.despacho.tituloDespacho.tituloProcessoDTO.conjuge.pessoaFisica.dataNascimento).toDate() : null : null,
        // -----
        naturalidadeOutorgado: this.isOutorgadoPessoaFisica ? (this.despacho.tituloDespacho.tituloProcessoDTO.outorgado.pessoaFisica.naturalidade ? this.despacho.tituloDespacho.tituloProcessoDTO.outorgado.pessoaFisica.naturalidade.nome : null) : null,
        ufNaturalidadeOutorgado: this.isOutorgadoPessoaFisica ? (this.despacho.tituloDespacho.tituloProcessoDTO.outorgado.pessoaFisica.naturalidade ? this.despacho.tituloDespacho.tituloProcessoDTO.outorgado.pessoaFisica.naturalidade.codigoEstado : null) : null,

        // -- Outorgado ENDERECO
        municipioNomeOutorgado: await this.getMunicipio(this.despacho.tituloDespacho.tituloProcessoDTO.outorgado?.endereco),
        municipioUfOutorgado: !this.isOutorgadoPessoaFisica ? this.despacho.tituloDespacho.tituloProcessoDTO.outorgado?.endereco?.municipio?.codigoEstado : '',
        logradouroOutorgado: !this.isOutorgadoPessoaFisica ? this.despacho.tituloDespacho.tituloProcessoDTO.outorgado?.endereco?.logradouro : '',
        numeroOutorgado: !this.isOutorgadoPessoaFisica ? this.despacho.tituloDespacho.tituloProcessoDTO.outorgado?.endereco?.numero : '',
        complementoOutorgado: !this.isOutorgadoPessoaFisica ? this.despacho.tituloDespacho.tituloProcessoDTO.outorgado?.endereco?.complemento : '',
        bairroOutorgado: !this.isOutorgadoPessoaFisica ? this.despacho.tituloDespacho.tituloProcessoDTO.outorgado?.endereco?.bairro : '',
        inscricaoEstadualOutorgado: this.despacho.tituloDespacho.tituloProcessoDTO.outorgado?.pessoaJuridica?.inscricaoEstadual,

        nomeConjuge: this.despacho.tituloDespacho.tituloProcessoDTO?.conjuge?.pessoaFisica?.nome,
        nacionalidadeConjuge: this.despacho.tituloDespacho.tituloProcessoDTO?.conjuge?.pessoaFisica?.gentilico,
        estadoCivilConjuge: this.despacho.tituloDespacho.tituloProcessoDTO?.conjuge?.pessoaFisica?.estadoCivil ? estadoCivil.find(e => e.codigo === this.despacho.tituloDespacho.tituloProcessoDTO.conjuge.pessoaFisica.estadoCivil).name : null,
        rgConjuge: this.despacho.tituloDespacho.tituloProcessoDTO?.conjuge?.pessoaFisica?.rg,
        orgaoExpedidorConjuge: this.mountOrgaoExpedidor(),
        descricaoOrgaoExpedidorConjuge: this.despacho.tituloDespacho.tituloProcessoDTO?.conjuge?.pessoaFisica?.descricaoOrgaoExpedidor,
        ufRgConjuge: this.despacho.tituloDespacho.tituloProcessoDTO?.conjuge?.pessoaFisica?.orgaoExpedidor?.estado,
        cpfCnpjConjuge: this.despacho.tituloDespacho.tituloProcessoDTO?.conjuge?.pessoaFisica?.cpf,
        naturalidadeConjuge: this.despacho.tituloDespacho.tituloProcessoDTO?.conjuge?.pessoaFisica?.naturalidade?.nome,
        ufNaturalidadeConjuge: this.despacho.tituloDespacho.tituloProcessoDTO?.conjuge?.pessoaFisica?.naturalidade?.codigoEstado,
        profissaoConjuge: this.despacho.tituloDespacho.tituloProcessoDTO?.conjuge?.pessoaFisica?.profissao,
        numeroProcesso: this.despacho.tituloDespacho.tituloProcessoDTO?.numeroProcesso || this.despacho.tituloDespacho?.documentoTitulo?.numeroProcesso,
        formaPoligono: this.despacho.tituloDespacho.tituloProcessoDTO.formaPoligono,
        testada: this.despacho.tituloDespacho.tituloProcessoDTO.testada || '',
        lados: this.despacho.tituloDespacho.tituloProcessoDTO?.portaria?.limites?.length ? this.despacho.tituloDespacho.tituloProcessoDTO?.portaria?.limites?.length : this.despacho.tituloDespacho.tituloProcessoDTO?.lados,
        tipoCoordenada: this.despacho.tituloDespacho.tituloProcessoDTO.tipoCoordenada,
        doe: this.doeFormatado(),
        natureza: this.naturezaFormatada(),
        // novos
        dataEmissao: this.getMomentToDate(this.despacho.tituloDespacho.tituloProcessoDTO.dataEmissao),
        portaria: this.despacho.portaria ? {
          localizacao: this.localizacaoImovel(),
          codigoImovel: this.despacho?.tituloDespacho?.tituloProcessoDTO?.portaria?.codigoImovel,
          municipio: {
            nome: this.isEstadoAP ? this.despacho?.tituloDespacho?.tituloProcessoDTO?.portaria?.municipios[0]?.nome : this.municipioImovel(),
            codigoEstado: this.isEstadoAP ? this.despacho?.tituloDespacho?.tituloProcessoDTO?.portaria?.municipios[0]?.codigoEstado : this.ufImovel()
          },
          denominacao: this.denominacaoImovel(),
          perimetro: this.perimetroGeral(),
          areaLiquida: this.despacho?.tituloDespacho?.tituloProcessoDTO?.portaria?.areaLiquida,
          declinacaoMagnetica: this.declinacao(),
          data: this.dataMedicao(),
          numero: this.despacho.portaria.numero,
          limites: this.despacho.portaria.limites?.length > 0 ? this.despacho.portaria.limites : this.despacho.limites,
          areaPorExtenso: this.numeroExtenso(this.despacho.portaria.areaLiquida, 'hectares'),
          norte: this.north(),
          east: this.east(),
          homologacaoSentenca: this.portariaFormatado(),
          areaTotal: this.despacho.tituloDespacho.tituloProcessoDTO?.portaria?.areaTotal,
          numeroPorta: this.despacho.tituloDespacho.tituloProcessoDTO?.portaria?.numeroPorta,
          numeroCadastroMunicipal: this.despacho.tituloDespacho.tituloProcessoDTO?.portaria?.numeroCadastroMunicipal,
          mesAnoMedicao: this.despacho.tituloDespacho.tituloProcessoDTO?.portaria?.mesAnoMedicao,
          memorialDescritivo: this.despacho.tituloDespacho.tituloProcessoDTO?.portaria?.memorialDescritivo || '',
          dadosParcela: this.despacho?.tituloDespacho?.tituloProcessoDTO?.portaria?.dadosParcela,
          municipios: this.despacho?.portaria?.municipios,
          numeroModuloFiscal: (this.isEstadoAP && this.despacho.tituloDespacho.tituloProcessoDTO?.portaria?.numeroModuloFiscal)
            ? this.despacho.tituloDespacho.tituloProcessoDTO?.portaria?.numeroModuloFiscal
            : this.getNumeroModulosFiscais(this.despacho?.portaria?.areaTotal, this.despacho?.portaria?.municipios ? this.despacho?.portaria?.municipios[0]?.mf : null),
          numeroPublicacaoPortaria: this.despacho.tituloDespacho?.tituloProcessoDTO?.numeroPublicacaoPortaria || '',
          confrontantes: this.despacho?.tituloDespacho?.tituloProcessoDTO?.portaria?.confrontantes || [],
          numeroSei: this.despacho?.tituloDespacho?.tituloProcessoDTO?.portaria?.numeroSei
        } : {
          codigoImovel: this.despacho?.tituloDespacho?.tituloProcessoDTO?.portaria?.codigoImovel,
          areaPorExtenso: this.numeroExtenso(this.despacho.tituloDespacho.tituloProcessoDTO?.portaria?.areaLiquida, 'hectares'),
          localizacao: this.despacho.tituloDespacho.tituloProcessoDTO?.portaria?.localizacao,
          municipio: this.isEstadoAP ? this.despacho?.tituloDespacho?.tituloProcessoDTO?.portaria?.municipios[0] : this.despacho.tituloDespacho.tituloProcessoDTO?.portaria?.municipio,
          denominacao: this.despacho.tituloDespacho.tituloProcessoDTO?.portaria?.denominacao,
          perimetro: this.despacho.tituloDespacho.tituloProcessoDTO?.portaria?.perimetro ? `${this.despacho.tituloDespacho.tituloProcessoDTO.portaria.perimetro}`?.replace('.', ',') : '',
          declinacaoMagnetica: this.despacho.tituloDespacho.tituloProcessoDTO?.portaria?.declinacaoMagnetica,
          areaTotal: this.despacho.tituloDespacho.tituloProcessoDTO?.portaria?.areaTotal ? `${this.despacho.tituloDespacho.tituloProcessoDTO.portaria.areaTotal}`?.replace('.', ',') : '',
          numeroPorta: this.despacho.tituloDespacho.tituloProcessoDTO?.portaria?.numeroPorta,
          numeroModuloFiscal: (this.isEstadoAP && this.despacho.tituloDespacho.tituloProcessoDTO?.portaria?.numeroModuloFiscal)
            ? this.despacho.tituloDespacho.tituloProcessoDTO?.portaria?.numeroModuloFiscal
            : this.getNumeroModulosFiscais(this.despacho.tituloDespacho.tituloProcessoDTO?.portaria?.areaTotal, this.despacho.tituloDespacho.tituloProcessoDTO?.portaria?.municipios?.length ? this.despacho.tituloDespacho.tituloProcessoDTO?.portaria?.municipios[0]?.mf : null),
          numeroCadastroMunicipal: this.despacho.tituloDespacho.tituloProcessoDTO?.portaria?.numeroCadastroMunicipal,
          mesAnoMedicao: this.despacho.tituloDespacho.tituloProcessoDTO?.portaria?.mesAnoMedicao,
          memorialDescritivo: this.despacho.tituloDespacho.tituloProcessoDTO?.portaria?.memorialDescritivo || '',
          dadosParcela: this.despacho?.tituloDespacho?.tituloProcessoDTO?.portaria?.dadosParcela,
          municipios: this.despacho?.tituloDespacho?.tituloProcessoDTO?.portaria?.municipios,
          areaLiquida: this.despacho.tituloDespacho.tituloProcessoDTO?.portaria?.areaLiquida ? this.isEstadoAP ? this.despacho.tituloDespacho.tituloProcessoDTO?.portaria?.areaLiquida : `${this.despacho.tituloDespacho.tituloProcessoDTO.portaria.areaLiquida}`.replace('.', ',') : '',
          east: !this.isEstadMA ? this.campoLeste(this.despacho?.tituloDespacho?.tituloProcessoDTO?.portaria?.memorialDescritivo) : '',
          norte: !this.isEstadMA ? this.campoNorte(this.despacho?.tituloDespacho?.tituloProcessoDTO?.portaria?.memorialDescritivo) : '',
          limites: this.despacho?.tituloDespacho?.tituloProcessoDTO?.portaria?.limites,
          numeroPublicacaoPortaria: this.despacho.tituloDespacho?.tituloProcessoDTO?.numeroPublicacaoPortaria || '',
          confrontantes: this.despacho?.tituloDespacho?.tituloProcessoDTO?.portaria?.confrontantes || [],
          numeroSei: this.despacho?.tituloDespacho?.tituloProcessoDTO?.portaria?.numeroSei
        },
        homologacaoSentenca: this.despacho?.tituloDespacho?.tituloProcessoDTO?.homologacaoSentenca,
        responsavelTecnico: this.despacho.tituloDespacho.tituloProcessoDTO?.responsavelTecnico?.toUpperCase(),
        informacoesRegistro: this.despacho.tituloDespacho.tituloProcessoDTO?.informacoesRegistro || '',
        embasamentoJuridico: this.despacho.tituloDespacho.tituloProcessoDTO?.embasamentoJuridico || '',
        // vtn
        valorVtn: this.despacho.tituloDespacho.tituloProcessoDTO.valorVtn,
        vtnPrazoInalienabilidade: this.despacho.tituloDespacho.tituloProcessoDTO.vtnPrazoInalienabilidade,
        valorFinalAposCarencia: this.despacho.tituloDespacho.tituloProcessoDTO.valorFinalAposCarencia,
        correcaoAnual: this.despacho.tituloDespacho.tituloProcessoDTO.correcaoAnual || 0,
        prazoCarencia: this.despacho.tituloDespacho.tituloProcessoDTO?.carenciaVtn,
        carenciaVtn: this.despacho.tituloDespacho.tituloProcessoDTO?.carenciaVtn,
        condicaoPagamento: (this.isEstadoAP && this.despacho.tituloDespacho.tituloProcessoDTO.condicaoPagamentoDinamica)
          ? this.despacho.tituloDespacho.tituloProcessoDTO.condicaoPagamentoDinamica
          : (this.isEstadoAP && this.isNaoOneroso() ? 'Não se aplica' : this.despacho.tituloDespacho.tituloProcessoDTO?.vtnParcelado ? 'Á PRAZO' : 'Á VISTA'),
        valorPrimeiraParcela: this.isEstadoAP ? utils.format(this.despacho.tituloDespacho.tituloProcessoDTO?.valorPrimeiraParcela?.toString(), this.optionFormat) : utils.formataValor(this.despacho.tituloDespacho.tituloProcessoDTO?.valorPrimeiraParcela?.toString(), 2, false),
        vencimentoPrimeiraParcela: this.despacho.tituloDespacho.tituloProcessoDTO?.dataVencimentoPrimeiraParcelaFormatada,
        valorPorcentagemDescontoVtn: this.despacho.tituloDespacho.tituloProcessoDTO.valorPorcentagemDescontoVtn,
        valorDescontoVtn: this.despacho.tituloDespacho.tituloProcessoDTO.valorDescontoVtn,
        valorCustasAgrariasVtn: this.despacho.tituloDespacho.tituloProcessoDTO.valorCustasAgrariasVtn,
        valorCustasProcessuaisVtn: this.despacho.tituloDespacho.tituloProcessoDTO.valorCustasProcessuaisVtn,
        valorTotalVtn: this.isEstadoAP ? this.despacho.tituloDespacho.tituloProcessoDTO.valorTotalVtn ? utils.format(this.despacho.tituloDespacho.tituloProcessoDTO.valorTotalVtn, this.optionFormat) : '' : this.despacho.tituloDespacho.tituloProcessoDTO.valorDescontoVtn +
          this.despacho.tituloDespacho.tituloProcessoDTO.valorCustasProcessuaisVtn +
          this.despacho.tituloDespacho.tituloProcessoDTO.taxaOcupacaoVtn,
        taxaOcupacaoVtn: this.despacho.tituloDespacho.tituloProcessoDTO.taxaOcupacaoVtn,
        taxaJurosAnual: this.despacho.tituloDespacho.tituloProcessoDTO.taxaJurosAnual,
        totalJuros: this.isEstadoAP ? utils.format(this.despacho.tituloDespacho.tituloProcessoDTO.totalJuros, this.optionFormat) : utils.formataValor(this.despacho.tituloDespacho.tituloProcessoDTO.totalJuros?.toString(), 2, false),
        valorPrestacao: this.despacho.tituloDespacho.tituloProcessoDTO.valorPrestacao,
        vtnParcelado: this.despacho.tituloDespacho.tituloProcessoDTO.vtnParcelado,
        valorEntradaVtn: this.despacho.tituloDespacho.tituloProcessoDTO.valorEntradaVtn,
        porcentagemEntradaVtn: this.despacho.tituloDespacho.tituloProcessoDTO.porcentagemEntradaVtn,
        quantidadeDeParcelas: this.despacho.tituloDespacho.tituloProcessoDTO.quantidadeDeParcelas,
        valorParcelasRestantes: this.despacho.tituloDespacho.tituloProcessoDTO.valorParcelasRestantes,
        vencimentoProximaParcela: this.despacho.tituloDespacho.tituloProcessoDTO.vencimentoProximaParcela,
        novaPortaria: this.despacho?.tituloDespacho?.tituloProcessoDTO?.novaPortaria,
        // campos RR

        faixaDeFronteira: !this.isEstadMA ? this.getFaixaFronteira(this.despacho?.tituloDespacho?.tituloProcessoDTO?.faixaDeFronteira) : '',
        assentimentoPrevio: this.despacho?.tituloDespacho?.tituloProcessoDTO?.assentimentoPrevio,
        sncr: this.despacho?.tituloDespacho?.tituloProcessoDTO?.sncr,
        sigef: this.despacho?.tituloDespacho?.tituloProcessoDTO?.sigef,
        norte: this.despacho?.tituloDespacho?.tituloProcessoDTO?.norte,
        sul: this.despacho?.tituloDespacho?.tituloProcessoDTO?.sul,
        leste: this.despacho?.tituloDespacho?.tituloProcessoDTO?.leste,
        oeste: this.despacho?.tituloDespacho?.tituloProcessoDTO?.oeste,
        gleba: this.despacho?.tituloDespacho?.tituloProcessoDTO?.gleba,
        proprietario: this.despacho?.tituloDespacho?.tituloProcessoDTO?.proprietario,
        matricula: this.despacho?.tituloDespacho?.tituloProcessoDTO?.matricula,
        frequenciaPagamento: this.despacho?.tituloDespacho?.tituloProcessoDTO?.frequenciaPagamento,
        indiceCorrecao: this.despacho?.tituloDespacho?.tituloProcessoDTO?.indiceCorrecao,
        valorVtnImovel: this.despacho?.tituloDespacho?.tituloProcessoDTO?.valorVtnImovel,
        valorVtnImovelAVista: this.despacho?.tituloDespacho?.tituloProcessoDTO?.valorVtnImovelAVista,
        valorMinimoVtn: this.despacho?.tituloDespacho?.tituloProcessoDTO?.valorMinimoVtn,
        valorVtntReserva: this.despacho?.tituloDespacho?.tituloProcessoDTO?.valorVtntReserva,
        valorVtntArea: this.despacho?.tituloDespacho?.tituloProcessoDTO?.valorVtntArea,
        latitude: this.despacho?.tituloDespacho?.tituloProcessoDTO?.latitude,
        longitude: this.despacho?.tituloDespacho?.tituloProcessoDTO?.longitude,
        nomeImovel: this.despacho?.tituloDespacho?.tituloProcessoDTO?.nomeImovel,
        glebaImovel: this.despacho?.tituloDespacho?.tituloProcessoDTO?.glebaImovel,
        areaImovel: utils.formataValor(this.despacho?.tituloDespacho?.tituloProcessoDTO?.areaImovel, 4, this.despacho?.tituloDespacho?.tituloProcessoDTO?.areaImovel?.includes(','), this.isReurbIndividual()),
        logradouroImovel: this.despacho?.tituloDespacho?.tituloProcessoDTO?.logradouroImovel,
        numeroImovel: this.despacho?.tituloDespacho?.tituloProcessoDTO?.numeroImovel,
        bairroImovel: this.despacho?.tituloDespacho?.tituloProcessoDTO?.bairroImovel,
        municipioImovel: this.despacho?.tituloDespacho?.tituloProcessoDTO?.municipioImovel,
        precoImovel: utils.formataValor(this.despacho?.tituloDespacho?.tituloProcessoDTO?.precoImovel, 2, this.despacho?.tituloDespacho?.tituloProcessoDTO?.precoImovel?.includes(',')),
        enderecoImovel: this.despacho?.tituloDespacho?.tituloProcessoDTO?.enderecoImovel,
        // campos MA
        matriculaImovel: this.despacho?.tituloDespacho?.tituloProcessoDTO?.matriculaImovel,
        livroMatriculaImovel: this.despacho?.tituloDespacho?.tituloProcessoDTO?.livroMatriculaImovel,
        folhaMatriculaImovel: this.despacho?.tituloDespacho?.tituloProcessoDTO?.folhaMatriculaImovel,
        municipioMatriculaImovel: this.despacho?.tituloDespacho?.tituloProcessoDTO?.municipioMatriculaImovel,
        cartorioMatriculaImovel: this.despacho?.tituloDespacho?.tituloProcessoDTO?.cartorioMatriculaImovel,
        quadraDeControle: this.despacho?.tituloDespacho?.tituloProcessoDTO?.quadraDeControle,
        numeroDeControle: this.despacho?.tituloDespacho?.tituloProcessoDTO?.numeroDeControle,
        // campos AP
        matRegTrans: this.despacho?.tituloDespacho?.tituloProcessoDTO?.matRegTrans,
        cns: this.despacho?.tituloDespacho?.tituloProcessoDTO?.cns,
        cartorio: this.despacho?.tituloDespacho?.tituloProcessoDTO?.cartorio
      }

      if (this.model?.portaria?.confrontantes?.length) {
        this.model.portaria.confrontantesFormatados = this.model.portaria.confrontantes.map(c => c.nomeImovel).join('; ')
      }

      if (this.isRetificacaoTitulo) {
        const group = this.schema.groups.find(group => group.codigo === 'caracteristica_model')
        const inputEspecie = group.fields.find(field => field.inputName === 'especie')
        inputEspecie.values = [{
          id: 'Errata de Título',
          name: 'ERRATA DE TÍTULO'
        }, {
          id: 'Outros',
          name: 'OUTROS'
        }]
        const inputNumeroTitulo = group.fields.find(field => field.inputName === 'numeroFolha')
        inputNumeroTitulo.disabled = false
        inputNumeroTitulo.validator = 'required'
        this.model.ufEmissao = 'MA'
        this.model.municipioEmissao = 'São Luís'
        this.model.especie = 'Errata de Título'
        this.setDadosCadastroErrataTitulo()
      }

      let group = schemas.emissao_titulo[this.nomeSchema].groups.find(group => group.codigo === 'RESUMO_MEMORIAL_DESCRITIVO')
      let field
      if (group?.fields) {
        field = group.fields.find(field => field.inputName === 'listagemLimites')
      }

      if (field) {
        field.values = this.despacho.tituloDespacho.tituloProcessoDTO?.portaria?.limites
      }

      this.habilitarEditaveis()
      this.setLimites()
      this.checkConjuge()
      this.habilitaCamposDoRepresentante()
      this.campoMunicipioMA()
      this.campoMunicipioAP()
    },

    getField (filter, grupo) {
      const group = schemas.emissao_titulo[this.nomeSchema].groups.find(group => group.codigo === grupo)
      if (group) {
        return group.fields.find(field => field.model === filter)
      }
    },

    getNumeroModulosFiscais (areaTotal, modulosFiscaisMunicipio) {
      if (areaTotal && modulosFiscaisMunicipio) {
        return (areaTotal / modulosFiscaisMunicipio).toFixed(4)
      }
      return 0
    },

    async onModelUpdated (newValue, schema) {
      if (schema.includes('orgaoExpedidorOutorgado')) {
        const fieldDescricao = this.getField('descricaoOrgaoExpedidorOutorgado', 'OUTORGADO')
        const isOutros = newValue === 'OUTROS' || (newValue && newValue.codigo === 'OUTROS')
        if (isOutros) {
          fieldDescricao.visible = true
          fieldDescricao.required = true
        } else {
          fieldDescricao.visible = false
          fieldDescricao.required = false
        }
      }
      if (schema.includes('orgaoExpedidorConjuge')) {
        const fieldDescricao = this.getField('descricaoOrgaoExpedidorConjuge', 'CONJUGE')
        const isOutros = newValue === 'OUTROS' || (newValue && newValue.codigo === 'OUTROS')
        if (isOutros) {
          fieldDescricao.visible = true
          fieldDescricao.required = true
        } else {
          fieldDescricao.visible = false
          fieldDescricao.required = false
        }
      }
      if (schema.includes('especie')) {
        const fieldDescricao = this.getField('descricao', 'caracteristica_model')
        if (newValue.id === 'Outros') {
          fieldDescricao.visible = true
          fieldDescricao.required = true
        } else {
          fieldDescricao.visible = false
          fieldDescricao.required = false
        }
      }
      if (schema.includes('representante')) {
        if (schema.includes('pessoa.pessoaFisica.nacionalidade')) {
          const fieldUf = this.getField(schema.replace('nacionalidade', 'naturalidade.codigoEstado'), 'OUTORGADO')
          const fieldMunicipio = this.getField(schema.replace('nacionalidade', 'naturalidade.nome'), 'OUTORGADO')
          if (fieldUf) {
            fieldUf.visible = newValue.codigo === 'BR'
            fieldUf.required = newValue.codigo === 'BR'
            fieldMunicipio.visible = newValue.codigo === 'BR'
            fieldMunicipio.required = newValue.codigo === 'BR'
          }
        } else if (schema.includes('pessoa.pessoaFisica.naturalidade.codigoEstado')) {
          const field = schema
          const fieldMunicipio = this.getField(schema.replace('naturalidade.codigoEstado', 'naturalidade.nome'), 'OUTORGADO')
          if (field) {
            const municipios = await this.findMunicipiosByUf(newValue.codigo)
            let municipiosList = municipios.map((municipio) => {
              return {
                id: municipio.id,
                codigo: municipio.nome,
                name: municipio.nome
              }
            })
            fieldMunicipio.values = municipiosList
            fieldMunicipio.disabled = false
          }
        } else if (schema.includes('pessoa.pessoaFisica.estadoCivil')) {
          const codigosEstadoCivil = ['CASADO', 'UNIAO_ESTAVEL', 'UNIAO_HOMOAFETIVA']
          const fieldConjugeNome = this.getField(schema.replace('pessoa.pessoaFisica.estadoCivil', 'conjuge.pessoaFisica.nome'), 'OUTORGADO')
          const fieldConjugeNacionalidade = this.getField(schema.replace('pessoa.pessoaFisica.estadoCivil', 'conjuge.pessoaFisica.nacionalidade'), 'OUTORGADO')
          const fieldConjugeRg = this.getField(schema.replace('pessoa.pessoaFisica.estadoCivil', 'conjuge.pessoaFisica.rg'), 'OUTORGADO')
          const fieldConjugeOrgaoExpedidor = this.getField(schema.replace('pessoa.pessoaFisica.estadoCivil', 'conjuge.pessoaFisica.orgaoExpedidor.nome'), 'OUTORGADO')
          const fieldConjugeUfRg = this.getField(schema.replace('pessoa.pessoaFisica.estadoCivil', 'conjuge.pessoaFisica.orgaoExpedidor.nomeEstado'), 'OUTORGADO')
          const fieldConjugeCpf = this.getField(schema.replace('pessoa.pessoaFisica.estadoCivil', 'conjuge.pessoaFisica.cpf'), 'OUTORGADO')
          const fieldConjugeDataNascimento = this.getField(schema.replace('pessoa.pessoaFisica.estadoCivil', 'conjuge.pessoaFisica.dataNascimento'), 'OUTORGADO')
          const value = codigosEstadoCivil.includes(newValue.codigo)
          if (
            fieldConjugeNome || fieldConjugeNacionalidade || fieldConjugeRg || fieldConjugeOrgaoExpedidor || fieldConjugeUfRg ||
            fieldConjugeCpf || fieldConjugeDataNascimento
          ) {
            if (!this.model.representanteLegais[parseInt(schema.split('[')[1].split(']')[0])].conjuge && value) {
              this.model.representanteLegais[parseInt(schema.split('[')[1].split(']')[0])].conjuge = {
                pessoaFisica: {
                }
              }
            } else if (!value) {
              this.model.representanteLegais[parseInt(schema.split('[')[1].split(']')[0])].conjuge = null
            }
            fieldConjugeNome.visible = value
            fieldConjugeNome.required = value
            fieldConjugeNacionalidade.visible = value
            fieldConjugeNacionalidade.required = value
            fieldConjugeRg.visible = value
            fieldConjugeRg.required = value
            fieldConjugeOrgaoExpedidor.visible = value
            fieldConjugeOrgaoExpedidor.required = value
            fieldConjugeUfRg.visible = value
            fieldConjugeUfRg.required = value
            fieldConjugeCpf.visible = value
            fieldConjugeCpf.required = value
            fieldConjugeDataNascimento.visible = value
            fieldConjugeDataNascimento.required = value
          }
        } else if (schema.includes('conjuge.pessoaFisica.nacionalidade')) {
          const fieldUf = this.getField(schema.replace('conjuge.pessoaFisica.nacionalidade', 'conjuge.pessoaFisica.naturalidade.codigoEstado'), 'OUTORGADO')
          const fieldMunicipio = this.getField(schema.replace('conjuge.pessoaFisica.nacionalidade', 'conjuge.pessoaFisica.naturalidade.nome'), 'OUTORGADO')
          if (fieldUf) {
            fieldUf.visible = newValue.codigo === 'BR'
            fieldUf.required = newValue.codigo === 'BR'
            fieldMunicipio.visible = newValue.codigo === 'BR'
            fieldMunicipio.required = newValue.codigo === 'BR'
          }
        } else if (schema.includes('conjuge.pessoaFisica.naturalidade.codigoEstado')) {
          const field = schema
          const fieldMunicipio = this.getField(schema.replace('.codigoEstado', '.nome'), 'OUTORGADO')
          if (field) {
            const municipios = await this.findMunicipiosByUf(newValue.codigo)
            let municipiosList = municipios.map((municipio) => {
              return {
                id: municipio.id,
                codigo: municipio.nome,
                name: municipio.nome
              }
            })
            fieldMunicipio.values = municipiosList
            fieldMunicipio.disabled = false
          }
        }
      }
    },

    habilitaCamposDoRepresentante () {
      const isConjuge = ['CASADO', 'UNIAO_ESTAVEL', 'UNIAO_HOMOAFETIVA']
      if (this.isRepresentantesLegais) {
        const group = schemas.emissao_titulo[this.nomeSchema].groups.find(group => group.codigo === 'OUTORGADO')
        this.despacho.tituloDespacho.tituloProcessoDTO.representanteLegais.forEach((r, index) => {
          if (group && index <= 2) {
            if (this.isEstadMA) {
              this.camposRepresentanteMa(group, isConjuge, index)
            } else {
              this.camposRepresentanteDefault(group, isConjuge, index)
            }
          }
        })
      }
    },

    camposRepresentanteDefault (group, isConjuge, index) {
      group.fields.push({
        column: 24,
        type: 'elementInput',
        model: `representanteLegais[${index}].pessoa.pessoaFisica.nome`,
        inputName: `${index + 1} - representanteLegais[${index}].pessoa.pessoaFisica.nome`,
        visible: true,
        disabled: true,
        required: true,
        validator: 'required',
        inputType: 'text',
        filterable: false,
        elementLabel: `${index + 1} - Representante Legal Do(a) Outorgado(a): `,
        clearable: true,
        visiblePf: true,
        visiblePj: true
      })
      group.fields.push({
        column: 6,
        type: 'elementSelect',
        model: `representanteLegais[${index}].pessoa.pessoaFisica.nacionalidade`,
        inputName: `${index + 1} - representanteLegais[${index}].pessoa.pessoaFisica.nacionalidade`,
        placeholder: 'Selecione',
        visible: true,
        disabled: false,
        required: true,
        validator: 'required',
        valueKey: 'codigo',
        value: 'codigo',
        values: gentilicos,
        filterable: false,
        elementLabel: 'Nacionalidade: ',
        visiblePf: true,
        visiblePj: false
      })
      group.fields.push({
        column: 6,
        type: 'elementInput',
        model: `representanteLegais[${index}].pessoa.pessoaFisica.rg`,
        inputName: `${index + 1} - representanteLegais[${index}].pessoa.pessoaFisica.rg`,
        visible: true,
        disabled: true,
        required: true,
        validator: 'required',
        readonly: false,
        inputType: 'text',
        elementLabel: 'Nº do RG: ',
        clearable: true,
        visiblePf: true,
        visiblePj: false
      })
      group.fields.push({
        column: 6,
        type: 'elementSelect',
        model: `representanteLegais[${index}].pessoa.pessoaFisica.orgaoExpedidor.nome`,
        inputName: `${index + 1} - representanteLegais[${index}].pessoa.pessoaFisica.orgaoExpedidor.nome`,
        placeholder: 'Selecione',
        visible: true,
        disabled: false,
        valueKey: 'codigo',
        values: orgaosExpedidores(),
        filterable: false,
        required: true,
        validator: 'required',
        elementLabel: 'Orgão expedidor: ',
        clearable: true,
        visiblePf: true,
        visiblePj: false
      })
      group.fields.push({
        column: 6,
        type: 'elementSelect',
        model: `representanteLegais[${index}].pessoa.pessoaFisica.orgaoExpedidor.nomeEstado`,
        inputName: `${index + 1} - representanteLegais[${index}].pessoa.pessoaFisica.orgaoExpedidor.nomeEstado`,
        placeholder: 'Selecione',
        visible: true,
        disabled: false,
        required: true,
        validator: 'required',
        valueKey: 'codigo',
        values: siglasEstados(),
        filterable: false,
        elementLabel: 'UF do RG: ',
        visiblePf: true,
        visiblePj: false
      })
      group.fields.push({
        column: 6,
        type: 'elementInput',
        model: `representanteLegais[${index}].pessoa.pessoaFisica.cpf`,
        inputName: `${index + 1} - representanteLegais[${index}].pessoa.pessoaFisica.cpf`,
        visible: true,
        disabled: true,
        required: true,
        validator: [validaCpfCnpj],
        readonly: false,
        inputType: 'text',
        elementLabel: 'CPF: ',
        clearable: true,
        visiblePf: true,
        visiblePj: true
      })
      group.fields.push({
        column: 6,
        type: 'elementSelect',
        model: `representanteLegais[${index}].pessoa.pessoaFisica.naturalidade.codigoEstado`,
        inputName: `representanteLegais[${index}].pessoa.pessoaFisica.naturalidade.codigoEstado`,
        placeholder: 'Selecione',
        visible: this.despacho.tituloDespacho.tituloProcessoDTO.representanteLegais[index].pessoa.pessoaFisica.gentilico === 'Brasileira',
        change: siglasEstados(),
        disabled: false,
        required: this.despacho.tituloDespacho.tituloProcessoDTO.representanteLegais[index].pessoa.pessoaFisica.gentilico === 'Brasileira',
        valueKey: 'codigo',
        values: siglasEstados(),
        filterable: false,
        validator: 'required',
        elementLabel: 'UF de Naturalidade: ',
        visiblePf: true,
        visiblePj: false
      })
      group.fields.push({
        column: 6,
        type: 'elementSelect',
        model: `representanteLegais[${index}].pessoa.pessoaFisica.naturalidade.nome`,
        inputName: `${index + 1} - representanteLegais[${index}].pessoa.pessoaFisica.naturalidade.nome`,
        placeholder: 'Selecione',
        visible: this.despacho.tituloDespacho.tituloProcessoDTO.representanteLegais[index].pessoa.pessoaFisica.gentilico === 'Brasileira',
        disabled: true,
        valueKey: 'codigo',
        values: [],
        filterable: false,
        required: this.despacho.tituloDespacho.tituloProcessoDTO.representanteLegais[index].pessoa.pessoaFisica.gentilico === 'Brasileira',
        validator: 'required',
        elementLabel: 'Naturalidade: ',
        visiblePf: true,
        visiblePj: false
      })
      group.fields.push({
        type: 'elementDatePicker',
        column: 6,
        model: `representanteLegais[${index}].pessoa.pessoaFisica.dataNascimento`,
        inputName: `${index + 1} - representanteLegais[${index}].pessoa.pessoaFisica.dataNascimento`,
        visible: true,
        disabled: false,
        required: true,
        validator: 'required',
        readonly: false,
        editable: false,
        clearable: true,
        firstDayOfWeek: 1,
        elementLabel: 'Data de Nascimento: ',
        placeholder: 'selecione a data',
        format: 'dd/MM/yyyy',
        dateType: 'date',
        visiblePf: true,
        visiblePj: false
      })
      group.fields.push({
        column: 6,
        type: 'elementSelect',
        model: `representanteLegais[${index}].pessoa.pessoaFisica.estadoCivil`,
        inputName: `${index + 1} - representanteLegais[${index}].pessoa.pessoaFisica.estadoCivil`,
        placeholder: 'Selecione',
        visible: true,
        disabled: false,
        valueKey: 'codigo',
        values: estadoCivil,
        filterable: false,
        required: true,
        validator: 'required',
        elementLabel: 'Estado Civil: ',
        visiblePf: true,
        visiblePj: false
      })
      group.fields.push({
        column: 24,
        type: 'elementInput',
        model: `representanteLegais[${index}].conjuge.pessoaFisica.nome`,
        inputName: `${index + 1} - representanteLegais[${index}].conjuge.pessoaFisica.nome`,
        visible: isConjuge.includes(this.despacho?.tituloDespacho?.tituloProcessoDTO?.representanteLegais[index]?.pessoa?.pessoaFisica?.estadoCivil),
        required: isConjuge.includes(this.despacho?.tituloDespacho?.tituloProcessoDTO?.representanteLegais[index]?.pessoa?.pessoaFisica?.estadoCivil),
        validator: 'required',
        inputType: 'text',
        filterable: false,
        elementLabel: `Cônjuge Representante Legal Do(a) Outorgado(a): `,
        clearable: true,
        visiblePf: true,
        visiblePj: true
      })
      group.fields.push({
        column: 6,
        type: 'elementSelect',
        model: `representanteLegais[${index}].conjuge.pessoaFisica.nacionalidade`,
        inputName: `${index + 1} - representanteLegais[${index}].conjuge.pessoaFisica.nacionalidade`,
        placeholder: 'Selecione',
        visible: isConjuge.includes(this.despacho?.tituloDespacho?.tituloProcessoDTO?.representanteLegais[index]?.pessoa?.pessoaFisica?.estadoCivil),
        disabled: false,
        required: isConjuge.includes(this.despacho?.tituloDespacho?.tituloProcessoDTO?.representanteLegais[index]?.pessoa?.pessoaFisica?.estadoCivil),
        validator: 'required',
        valueKey: 'codigo',
        value: 'codigo',
        values: gentilicos,
        filterable: false,
        elementLabel: 'Nacionalidade do Cônjuge: ',
        visiblePf: true,
        visiblePj: false
      })
      group.fields.push({
        column: 6,
        type: 'elementInput',
        model: `representanteLegais[${index}].conjuge.pessoaFisica.rg`,
        inputName: `${index + 1} - representanteLegais[${index}].conjuge.pessoaFisica.rg`,
        visible: isConjuge.includes(this.despacho?.tituloDespacho?.tituloProcessoDTO?.representanteLegais[index]?.pessoa?.pessoaFisica?.estadoCivil),
        disabled: false,
        required: isConjuge.includes(this.despacho?.tituloDespacho?.tituloProcessoDTO?.representanteLegais[index]?.pessoa?.pessoaFisica?.estadoCivil),
        validator: 'required',
        readonly: false,
        inputType: 'text',
        elementLabel: 'Nº do RG do Cônjuge: ',
        clearable: true,
        visiblePf: true,
        visiblePj: false
      })
      group.fields.push({
        column: 6,
        type: 'elementSelect',
        model: `representanteLegais[${index}].conjuge.pessoaFisica.orgaoExpedidor.nome`,
        inputName: `${index + 1} - representanteLegais[${index}].conjuge.pessoaFisica.orgaoExpedidor.nome`,
        placeholder: 'Selecione',
        visible: isConjuge.includes(this.despacho?.tituloDespacho?.tituloProcessoDTO?.representanteLegais[index]?.pessoa?.pessoaFisica?.estadoCivil),
        disabled: false,
        valueKey: 'codigo',
        values: orgaosExpedidores(),
        filterable: false,
        required: isConjuge.includes(this.despacho?.tituloDespacho?.tituloProcessoDTO?.representanteLegais[index]?.pessoa?.pessoaFisica?.estadoCivil),
        validator: 'required',
        elementLabel: 'Orgão expedidor do Cônjuge: ',
        clearable: true,
        visiblePf: true,
        visiblePj: false
      })
      group.fields.push({
        column: 6,
        type: 'elementSelect',
        model: `representanteLegais[${index}].conjuge.pessoaFisica.orgaoExpedidor.nomeEstado`,
        inputName: `${index + 1} - representanteLegais[${index}].conjuge.pessoaFisica.orgaoExpedidor.nomeEstado`,
        placeholder: 'Selecione',
        visible: isConjuge.includes(this.despacho?.tituloDespacho?.tituloProcessoDTO?.representanteLegais[index]?.pessoa?.pessoaFisica?.estadoCivil),
        disabled: false,
        required: isConjuge.includes(this.despacho?.tituloDespacho?.tituloProcessoDTO?.representanteLegais[index]?.pessoa?.pessoaFisica?.estadoCivil),
        validator: 'required',
        valueKey: 'codigo',
        values: siglasEstados(),
        filterable: false,
        elementLabel: 'UF do RG do Cônjuge: ',
        visiblePf: true,
        visiblePj: false
      })
      group.fields.push({
        column: 6,
        type: 'elementInput',
        model: `representanteLegais[${index}].conjuge.pessoaFisica.cpf`,
        inputName: `${index + 1} - representanteLegais[${index}].conjuge.pessoaFisica.cpf`,
        visible: isConjuge.includes(this.despacho?.tituloDespacho?.tituloProcessoDTO?.representanteLegais[index]?.pessoa?.pessoaFisica?.estadoCivil),
        disabled: false,
        required: isConjuge.includes(this.despacho?.tituloDespacho?.tituloProcessoDTO?.representanteLegais[index]?.pessoa?.pessoaFisica?.estadoCivil),
        validator: [validaCpfCnpj],
        readonly: false,
        inputType: 'text',
        elementLabel: 'CPF do Cônjuge: ',
        clearable: true,
        visiblePf: true,
        visiblePj: true
      })
      group.fields.push({
        column: 6,
        type: 'elementSelect',
        model: `representanteLegais[${index}].conjuge.pessoaFisica.naturalidade.codigoEstado`,
        inputName: `representanteLegais[${index}].conjuge.pessoaFisica.naturalidade.codigoEstado`,
        placeholder: 'Selecione',
        visible: this.despacho?.tituloDespacho?.tituloProcessoDTO?.representanteLegais[index]?.conjuge?.pessoaFisica?.nacionalidade === 'BR',
        change: siglasEstados(),
        disabled: false,
        required: this.despacho?.tituloDespacho?.tituloProcessoDTO?.representanteLegais[index]?.conjuge?.pessoaFisica?.nacionalidade === 'BR',
        valueKey: 'codigo',
        values: siglasEstados(),
        filterable: false,
        validator: 'required',
        elementLabel: 'UF de Naturalidade do Cônjuge: ',
        visiblePf: true,
        visiblePj: false
      })
      group.fields.push({
        column: 6,
        type: 'elementSelect',
        model: `representanteLegais[${index}].conjuge.pessoaFisica.naturalidade.nome`,
        inputName: `${index + 1} - representanteLegais[${index}].conjuge.pessoaFisica.naturalidade.nome`,
        placeholder: 'Selecione',
        visible: this.despacho?.tituloDespacho?.tituloProcessoDTO?.representanteLegais[index]?.conjuge?.pessoaFisica?.nacionalidade === 'BR',
        disabled: true,
        valueKey: 'codigo',
        values: [],
        filterable: false,
        required: this.despacho?.tituloDespacho?.tituloProcessoDTO?.representanteLegais[index]?.conjuge?.pessoaFisica?.nacionalidade === 'BR',
        validator: 'required',
        elementLabel: 'Naturalidade do Cônjuge: ',
        visiblePf: true,
        visiblePj: false
      })
      group.fields.push({
        type: 'elementDatePicker',
        column: 6,
        model: `representanteLegais[${index}].conjuge.pessoaFisica.dataNascimento`,
        inputName: `${index + 1} - representanteLegais[${index}].conjuge.pessoaFisica.dataNascimento`,
        visible: isConjuge.includes(this.despacho?.tituloDespacho?.tituloProcessoDTO?.representanteLegais[index]?.pessoa?.pessoaFisica?.estadoCivil),
        disabled: false,
        required: isConjuge.includes(this.despacho?.tituloDespacho?.tituloProcessoDTO?.representanteLegais[index]?.pessoa?.pessoaFisica?.estadoCivil),
        validator: 'required',
        readonly: false,
        editable: false,
        clearable: true,
        firstDayOfWeek: 1,
        elementLabel: 'Data de Nascimento do Cônjuge: ',
        placeholder: 'selecione a data',
        format: 'dd/MM/yyyy',
        dateType: 'date',
        visiblePf: true,
        visiblePj: false
      })
    },

    camposRepresentanteMa (group, isConjuge, index) {
      group.fields.push({
        column: 24,
        type: 'elementInput',
        model: `representanteLegais[${index}].pessoa.pessoaFisica.nome`,
        inputName: `${index + 1} - representanteLegais[${index}].pessoa.pessoaFisica.nome`,
        visible: true,
        disabled: false,
        required: false,
        inputType: 'text',
        filterable: false,
        elementLabel: `${index + 1} - Representante Legal Do(a) Outorgado(a): `,
        clearable: true,
        visiblePf: true,
        visiblePj: true
      })
      group.fields.push({
        column: 6,
        type: 'elementSelect',
        model: `representanteLegais[${index}].pessoa.pessoaFisica.nacionalidade`,
        inputName: `${index + 1} - representanteLegais[${index}].pessoa.pessoaFisica.nacionalidade`,
        placeholder: 'Selecione',
        visible: true,
        disabled: false,
        required: false,
        valueKey: 'codigo',
        value: 'codigo',
        values: gentilicos,
        filterable: false,
        elementLabel: 'Nacionalidade: ',
        visiblePf: true,
        visiblePj: false
      })
      group.fields.push({
        column: 6,
        type: 'elementInput',
        model: `representanteLegais[${index}].pessoa.pessoaFisica.rg`,
        inputName: `${index + 1} - representanteLegais[${index}].pessoa.pessoaFisica.rg`,
        visible: true,
        disabled: false,
        required: false,
        readonly: false,
        inputType: 'text',
        elementLabel: 'Nº do RG: ',
        clearable: true,
        visiblePf: true,
        visiblePj: false
      })
      group.fields.push({
        column: 6,
        type: 'elementSelect',
        model: `representanteLegais[${index}].pessoa.pessoaFisica.orgaoExpedidor.nome`,
        inputName: `${index + 1} - representanteLegais[${index}].pessoa.pessoaFisica.orgaoExpedidor.nome`,
        placeholder: 'Selecione',
        visible: true,
        disabled: false,
        valueKey: 'codigo',
        values: orgaosExpedidores(),
        filterable: false,
        required: false,
        elementLabel: 'Orgão expedidor: ',
        clearable: true,
        visiblePf: true,
        visiblePj: false
      })
      group.fields.push({
        column: 6,
        type: 'elementSelect',
        model: `representanteLegais[${index}].pessoa.pessoaFisica.orgaoExpedidor.nomeEstado`,
        inputName: `${index + 1} - representanteLegais[${index}].pessoa.pessoaFisica.orgaoExpedidor.nomeEstado`,
        placeholder: 'Selecione',
        visible: true,
        disabled: false,
        required: false,
        valueKey: 'codigo',
        values: siglasEstados(),
        filterable: false,
        elementLabel: 'UF do RG: ',
        visiblePf: true,
        visiblePj: false
      })
      group.fields.push({
        column: 6,
        type: 'elementInput',
        model: `representanteLegais[${index}].pessoa.pessoaFisica.cpf`,
        inputName: `${index + 1} - representanteLegais[${index}].pessoa.pessoaFisica.cpf`,
        visible: true,
        disabled: false,
        required: true,
        validator: [validaCpfCnpj],
        readonly: false,
        inputType: 'text',
        elementLabel: 'CPF: ',
        clearable: true,
        visiblePf: true,
        visiblePj: true
      })
      group.fields.push({
        column: 6,
        type: 'elementSelect',
        model: `representanteLegais[${index}].pessoa.pessoaFisica.naturalidade.codigoEstado`,
        inputName: `representanteLegais[${index}].pessoa.pessoaFisica.naturalidade.codigoEstado`,
        placeholder: 'Selecione',
        visible: this.despacho.tituloDespacho.tituloProcessoDTO.representanteLegais[index].pessoa.pessoaFisica.gentilico === 'Brasileira',
        change: siglasEstados(),
        disabled: false,
        required: false,
        valueKey: 'codigo',
        values: siglasEstados(),
        filterable: false,
        elementLabel: 'UF de Naturalidade: ',
        visiblePf: true,
        visiblePj: false
      })
      group.fields.push({
        column: 6,
        type: 'elementSelect',
        model: `representanteLegais[${index}].pessoa.pessoaFisica.naturalidade.nome`,
        inputName: `${index + 1} - representanteLegais[${index}].pessoa.pessoaFisica.naturalidade.nome`,
        placeholder: 'Selecione',
        visible: this.despacho.tituloDespacho.tituloProcessoDTO.representanteLegais[index].pessoa.pessoaFisica.gentilico === 'Brasileira',
        disabled: false,
        valueKey: 'codigo',
        values: [],
        filterable: false,
        required: false,
        elementLabel: 'Naturalidade: ',
        visiblePf: true,
        visiblePj: false
      })
      group.fields.push({
        type: 'elementDatePicker',
        column: 6,
        model: `representanteLegais[${index}].pessoa.pessoaFisica.dataNascimento`,
        inputName: `${index + 1} - representanteLegais[${index}].pessoa.pessoaFisica.dataNascimento`,
        visible: true,
        disabled: false,
        required: false,
        readonly: false,
        editable: false,
        clearable: true,
        firstDayOfWeek: 1,
        elementLabel: 'Data de Nascimento: ',
        placeholder: 'selecione a data',
        format: 'dd/MM/yyyy',
        dateType: 'date',
        visiblePf: true,
        visiblePj: false
      })
      group.fields.push({
        column: 6,
        type: 'elementSelect',
        model: `representanteLegais[${index}].pessoa.pessoaFisica.estadoCivil`,
        inputName: `${index + 1} - representanteLegais[${index}].pessoa.pessoaFisica.estadoCivil`,
        placeholder: 'Selecione',
        visible: true,
        disabled: false,
        valueKey: 'codigo',
        values: estadoCivil,
        filterable: false,
        required: false,
        elementLabel: 'Estado Civil: ',
        visiblePf: true,
        visiblePj: false
      })
    },

    async campoMunicipioMA () {
      if (this.isEstadMA) {
        const fieldMunicipio = this.getField('municipioImovel', 'CARACTERISTICA_IMOVEL')
        const fieldMunicipioMatricula = this.getField('municipioMatriculaImovel', 'DADOS_REGISTRO')
        const municipios = await this.findMunicipiosByUf('MA')
        let municipiosList = municipios.map((municipio) => {
          return {
            id: municipio.id,
            codigo: municipio.nome,
            name: municipio.nome.toUpperCase()
          }
        })
        if (fieldMunicipio) {
          fieldMunicipio.values = municipiosList
        }
        if (fieldMunicipioMatricula) {
          fieldMunicipioMatricula.values = municipiosList
        }
      }
    },
    async campoMunicipioAP () {
      if (this.isEstadoAP) {
        const fieldMunicipio = this.getField('comarca', 'DADOS_REGISTRO_GLEBA')
        const fieldMunicipioPortaria = this.getField('portaria.municipio.nome', 'CARACTERISTICA_IMOVEL')

        const municipios = await this.findMunicipiosByUf('AP')
        let municipiosList = municipios.map((municipio) => {
          return {
            id: municipio.id,
            codigo: municipio.nome,
            name: municipio.nome
          }
        })
        if (fieldMunicipio) {
          fieldMunicipio.values = municipiosList
        }

        if (fieldMunicipioPortaria) {
          fieldMunicipioPortaria.values = municipiosList
        }
      }
    },

    habilitarEditaveis () {
      const group = schemas.emissao_titulo[this.nomeSchema].groups.find(group => group.codigo === 'OUTORGADO')
      if (group) {
        group.fields.forEach((field) => {
          if (field) {
            if (this.isOutorgadoPessoaFisica) {
              field.visible = field.visiblePf
            } else {
              field.visible = field.visiblePj
            }
          }
        })
      }

      if (this.despacho.tituloDespacho.tituloProcessoDTO.camposEditaveis && this.despacho.tituloDespacho.tituloProcessoDTO.camposEditaveis.length > 0) {
        this.despacho.tituloDespacho.tituloProcessoDTO.camposEditaveis.forEach((campo) => {
          schemas.emissao_titulo[this.nomeSchema].groups.forEach((grupo) => {
            if (grupo?.fields) {
              const field = grupo.fields.find(field => field.inputName === campo)
              if (field) {
                field.disabled = false
                field.required = true
              }
            }
          })
        })
      }

      if (this.despacho.processo.tipo.codigo === 'ONEROSO' && !this.despacho.tituloDespacho.tituloProcessoDTO.vtnParcelado) {
        this.camposVtnParcela.forEach((campo) => {
          schemas.emissao_titulo[this.nomeSchema].groups.forEach((grupo) => {
            const field = grupo.fields.find(field => field.inputName === campo)
            if (field) {
              field.disabled = true
              field.required = false
              field.visible = false
            }
          })
        })
      }
    },

    campoLeste (memorial) {
      if (memorial) {
        const inicio = memorial.indexOf('E')
        const fim = memorial.indexOf(';')
        const memorialLeste = memorial.slice(inicio, fim + 1).replace(/\s/g, '')
        const inicioLeste = memorialLeste.indexOf('=')
        const fimLeste = memorialLeste.indexOf(';')
        return memorialLeste.slice(inicioLeste + 1, fimLeste)
      }
      return null
    },

    campoNorte (memorial) {
      if (memorial) {
        const inicio = memorial.indexOf('N')
        const fim = memorial.indexOf('m ')
        const memorialNorte = memorial.slice(inicio, fim + 1).replace(/\s/g, '')
        const inicioLeste = memorialNorte.indexOf('=')
        const fimLeste = memorialNorte.indexOf('m')
        return memorialNorte.slice(inicioLeste + 1, fimLeste + 1)
      }
      return null
    },

    async setDadosImovel (dadosImovel) {
      if (dadosImovel) {
        const municipios = await this.findMunicipiosByUf('MA')
        if (this.isReurbIndividual()) {
          const municipioImovel = municipios.find((obj) => obj.id === dadosImovel.municipio)
          this.model.bairroImovel = this.model.bairroImovel || dadosImovel.povoado
          this.model.municipioImovel = this.model.municipioImovel || municipioImovel?.nome
          this.model.numeroDeControle = this.model.numeroDeControle || dadosImovel.numeroDeControle
          this.model.quadraDeControle = this.model.quadraDeControle || dadosImovel.quadraDeControle
          this.model.logradouroImovel = this.model.logradouroImovel || dadosImovel.logradouro
          let areaImovel = dadosImovel.areaImovel ? dadosImovel.areaImovel.toString() : ''
          this.model.areaImovel = this.model.areaImovel || utils.formataValor(areaImovel, 4, areaImovel.includes(','))
        } else {
          const municipioImovel = municipios.find((obj) => obj.id === dadosImovel.municipio)
          const municipioCartorio = municipios.find((obj) => obj.id === dadosImovel.municipioCartorio)
          this.model.cartorioMatriculaImovel = dadosImovel.cartorio
          this.model.folhaMatriculaImovel = dadosImovel.folha
          this.model.glebaImovel = dadosImovel.gleba
          this.model.municipioImovel = municipioImovel?.nome
          this.model.municipioMatriculaImovel = municipioCartorio?.nome
          this.model.latitude = dadosImovel.latitude
          this.model.livroMatriculaImovel = dadosImovel.livro
          this.model.longitude = dadosImovel.longitude
          this.model.matriculaImovel = dadosImovel.matricula
          this.model.bairroImovel = dadosImovel.povoado
          this.model.cartorio = dadosImovel.cartorio
        }
      }
    },

    isNaoOneroso () {
      return ['NAO_ONEROSO', 'NAO_ONEROSO_FISICO'].includes(this.despacho.processo.tipo.codigo)
    },

    isOnerosoNaoOneroso () {
      return ['ONEROSO', 'NAO_ONEROSO', 'NAO_ONEROSO_FISICO', 'ONEROSO_FISICO'].includes(this.despacho.processo.tipo.codigo)
    },
    isReurbIndividual () {
      return ['REURB_INDIVIDUAL'].includes(this.despacho.processo.tipo.codigo)
    }
  }
}

</script>
<style lang="scss">
@import "@/assets/styles/_variables.scss";

.none {
  border: none;
}
.el-form-item__content {
  text-align: left;
}

.el-form-item__content .el-select {
  width: 100%;
}

.el-form-item__label {
  color: $font-dark-color;
  font-size: 14px;
  font-weight: bold;
}

// .el-form-item__label::after {
//   content: "*";
//   color: firebrick;
//   font-size: 14px;
//   font-weight: bold;
// }

.error {
  .field-wrap {
    .el-form-item {
      .el-form-item__content {
        border: 1px solid firebrick;
        border-radius: 10px;
        border-color: firebrick;
        -webkit-box-shadow: inset 0 1px 2px #ff867c , 0 0 9px firebrick;
        box-shadow: inset 0 1px 2px #ff867c, 0 0 4px #ff867c;
      }
    }
  }
}

.erro {
  border: 1px solid firebrick;
  border-radius: 4px;
  border-color: firebrick;
  -webkit-box-shadow: inset 0 1px 2px #ff867c , 0 0 9px firebrick;
  box-shadow: inset 0 1px 2px #ff867c, 0 0 4px #ff867c;
}

.help-block {
  color: firebrick;
}

.app-container {
  border: 1px solid #ebebeb;
  border-radius: 3px;
  transition: 0.2s;
  width: 50%;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/components/AppFormularioTitulo.vue